(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mio-core"));
	else if(typeof define === 'function' && define.amd)
		define(["mio-core"], factory);
	else if(typeof exports === 'object')
		exports["Foundation"] = factory(require("mio-core"));
	else
		root["Foundation"] = factory(root["mio-core"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_mio_core__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./sources/Array.ts":
/*!**************************!*\
  !*** ./sources/Array.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
Array.prototype.addObject = function (object) {
    this.push(object);
};
Array.prototype.removeObject = function (object) {
    var index = this.indexOf(object);
    if (index > -1) {
        this.splice(index, 1);
    }
};
Array.prototype.removeObjectAtIndex = function (index) {
    this.splice(index, 1);
};
Array.prototype.indexOfObject = function (object) {
    return this.indexOf(object);
};
Array.prototype.containsObject = function (object) {
    var index = this.indexOf(object);
    return index > -1 ? true : false;
};
Array.prototype.objectAtIndex = function (index) {
    return this[index];
};
Object.defineProperty(Array.prototype, "count", {
    get: function () {
        return this.length;
    },
    enumerable: true,
    configurable: true
});
Array.prototype.firstObject = function () {
    return this[0];
};
Array.prototype.lastObject = function () {
    return this[this.count - 1];
};



/***/ }),

/***/ "./sources/Bundle.ts":
/*!***************************!*\
  !*** ./sources/Bundle.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bundle: () => (/* binding */ Bundle),
/* harmony export */   _MIOBundleAppGetResource: () => (/* binding */ _MIOBundleAppGetResource),
/* harmony export */   _MIOBundleCreateBundle: () => (/* binding */ _MIOBundleCreateBundle),
/* harmony export */   _MIOBundleLoadBundles: () => (/* binding */ _MIOBundleLoadBundles),
/* harmony export */   _MIOBundleResourceDownloadCheck: () => (/* binding */ _MIOBundleResourceDownloadCheck),
/* harmony export */   _MIOBundleSetResource: () => (/* binding */ _MIOBundleSetResource)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _NSLog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NSLog */ "./sources/NSLog.ts");
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/**
 * Created by godshadow on 9/4/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Bundle = /** @class */ (function (_super) {
    __extends(Bundle, _super);
    function Bundle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Bundle, "main", {
        get: function () {
            if (this._mainBundle == null) {
                var urlString = (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetMainURLString)();
                this._mainBundle = new Bundle();
                this._mainBundle.initWithURL(new URL(urlString));
            }
            return this._mainBundle;
        },
        enumerable: false,
        configurable: true
    });
    Bundle.prototype.initWithURL = function (url) {
        this.url = url;
    };
    Bundle.prototype.loadNibNamed = function (name, owner, options) {
        var path = (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetMainURLString)() + "/" + name;
        (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetContentsFromURLString)(path, this, function (code, data) {
            owner._didLoadNibWithLayerData(data);
        });
    };
    Bundle.prototype.pathForResourceOfType = function (resource, type) {
        return _MIOBundleAppGetResource("Main", resource, type);
    };
    return Bundle;
}(_NSObject__WEBPACK_IMPORTED_MODULE_2__.NSObject));

function MIOCoreBundleDownloadResource(name, extension, target, completion) {
    // let resource = name + "." + extension;
    // let request = NSURLRequest.requestWithURL(NSURL.urlWithString(resource));
    // let con = new NSURLConnection();
    // con.initWithRequestBlock(request, target, function(code, data){
    //     if (code == 200) {                
    //         MIOCoreBundleSetAppResource(name, extension, data);
    //     }
    //     completion.call(target, data);
    // });        
}
var _MIOCoreBundleLoadCompletion;
function _MIOBundleLoadBundles(urlString, completion) {
    // Download and create the App Bundles    
    _MIOCoreBundleLoadCompletion = completion;
    (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetContentsFromURLString)(urlString, this, function (code, data) {
        if (code != 200) {
            completion(new Error("Bundles not found!"));
            return;
        }
        // Process the data
        var bundleJSON = null;
        try {
            bundleJSON = JSON.parse(data.replace(/(\r\n|\n|\r)/gm, ""));
        }
        catch (error) {
            (0,_NSLog__WEBPACK_IMPORTED_MODULE_1__.NSLog)("BUNDLE JSON PARSER ERROR: " + error);
            (0,_NSLog__WEBPACK_IMPORTED_MODULE_1__.NSLog)("BUNDLE JSON PARSER DATA: " + data);
            completion(new Error("BUNDLE JSON PARSER ERROR"));
            return;
        }
        // Keep going
        _MIOBundleResourcesDownloadingCount = 0;
        for (var key in bundleJSON) {
            var resources = bundleJSON[key];
            _MIOBundleResourcesDownloadingCount += resources.length;
            _MIOBundleCreateBundle(key, resources);
        }
    });
}
var _MIOBundleResourcesDownloadingCount = 0;
function _MIOBundleCreateBundle(key, resources) {
    var _loop_1 = function (urlString) {
        (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetContentsFromURLString)(urlString, this_1, function (code, data) {
            _MIOBundleResourcesDownloadingCount--;
            if (code == 200) {
                var type = urlString.match(/\.[0-9a-z]+$/i);
                if (type != null && type.length > 0)
                    type = type[0].substring(1);
                var resource = type != null ? urlString.substring(0, urlString.length - type.length - 1) : urlString;
                _MIOBundleSetResource(key, resource, type, data);
            }
            _MIOBundleResourceDownloadCheck();
        });
    };
    var this_1 = this;
    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
        var urlString = resources_1[_i];
        _loop_1(urlString);
    }
}
function _MIOBundleResourceDownloadCheck() {
    if (_MIOBundleResourcesDownloadingCount > 0)
        return;
    _MIOCoreBundleLoadCompletion(null);
    _MIOCoreBundleLoadCompletion = null;
}
var _MIOAppBundles = {};
function _MIOBundleSetResource(identifier, resource, type, content) {
    console.log("ID: " + identifier + ", " + resource + ", " + type);
    var bundle = _MIOAppBundles[identifier];
    if (bundle == null) {
        bundle = {};
        _MIOAppBundles[identifier] = bundle;
    }
    var t = type;
    if (type == null)
        t = "NO_TYPE";
    var files = bundle[t];
    if (files == null) {
        files = {};
        bundle[t] = files;
    }
    files[resource] = content;
}
function _MIOBundleAppGetResource(identifier, resource, type) {
    var bundle = _MIOAppBundles[identifier];
    if (bundle == null)
        return null;
    var t = type;
    if (type == null)
        t = "NO_TYPE";
    var files = bundle[t];
    if (files == null)
        return null;
    var content = files[resource];
    return content;
}


/***/ }),

/***/ "./sources/Calendar.ts":
/*!*****************************!*\
  !*** ./sources/Calendar.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Calendar: () => (/* binding */ Calendar),
/* harmony export */   CalendarUnit: () => (/* binding */ CalendarUnit)
/* harmony export */ });
/* harmony import */ var _Locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Locale */ "./sources/Locale.ts");
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var CalendarUnit;
(function (CalendarUnit) {
    CalendarUnit[CalendarUnit["era"] = 0] = "era";
    CalendarUnit[CalendarUnit["year"] = 1] = "year";
    CalendarUnit[CalendarUnit["yearForWeekOfYear"] = 2] = "yearForWeekOfYear";
    CalendarUnit[CalendarUnit["quarter"] = 3] = "quarter";
    CalendarUnit[CalendarUnit["month"] = 4] = "month";
    CalendarUnit[CalendarUnit["weekOfYear"] = 5] = "weekOfYear";
    CalendarUnit[CalendarUnit["weekOfMonth"] = 6] = "weekOfMonth";
    CalendarUnit[CalendarUnit["weekday"] = 7] = "weekday";
    CalendarUnit[CalendarUnit["weekdayOrdinal"] = 8] = "weekdayOrdinal";
    CalendarUnit[CalendarUnit["day"] = 9] = "day";
    CalendarUnit[CalendarUnit["hour"] = 10] = "hour";
    CalendarUnit[CalendarUnit["minute"] = 11] = "minute";
    CalendarUnit[CalendarUnit["second"] = 12] = "second";
    CalendarUnit[CalendarUnit["nanosecond"] = 13] = "nanosecond";
    CalendarUnit[CalendarUnit["calendar"] = 14] = "calendar";
    CalendarUnit[CalendarUnit["timeZone"] = 15] = "timeZone";
})(CalendarUnit || (CalendarUnit = {}));
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._locale = null;
        return _this;
    }
    Calendar.prototype.firstWeekday = function () {
        var day = 0;
        switch (this.locale.region) {
            case "US":
            case "UK":
            case "AR":
                day = 0;
                break;
            default:
                day = 1;
                break;
        }
        return day;
    };
    Calendar.prototype.getLocale = function () {
        if (this._locale == null)
            return _Locale__WEBPACK_IMPORTED_MODULE_0__.Locale.currentLocale();
        return this._locale;
    };
    Calendar.prototype.setLocale = function (locale) {
        this._locale = locale;
    };
    Object.defineProperty(Calendar.prototype, "locale", {
        get: function () { return this.getLocale(); },
        set: function (locale) { this.setLocale(locale); },
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.componentFromDate = function (component, date) {
        if (component == CalendarUnit.weekday) {
            var day = date.getDay(); // O means Sunday
            day -= this.firstWeekday(); // We decrement the first the of the week depends on the calendar
            if (day < 0) {
                day = 7 + day;
            }
            return day;
        }
        return 0;
    };
    return Calendar;
}(_NSObject__WEBPACK_IMPORTED_MODULE_1__.NSObject));



/***/ }),

/***/ "./sources/DateFormatter.ts":
/*!**********************************!*\
  !*** ./sources/DateFormatter.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DateFormatter: () => (/* binding */ DateFormatter),
/* harmony export */   DateFormatterStyle: () => (/* binding */ DateFormatterStyle)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Formatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Formatter */ "./sources/Formatter.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var DateFormatterStyle;
(function (DateFormatterStyle) {
    DateFormatterStyle[DateFormatterStyle["NoStyle"] = 0] = "NoStyle";
    DateFormatterStyle[DateFormatterStyle["ShortStyle"] = 1] = "ShortStyle";
    DateFormatterStyle[DateFormatterStyle["MediumStyle"] = 2] = "MediumStyle";
    DateFormatterStyle[DateFormatterStyle["LongStyle"] = 3] = "LongStyle";
    DateFormatterStyle[DateFormatterStyle["FullStyle"] = 4] = "FullStyle";
})(DateFormatterStyle || (DateFormatterStyle = {}));
var DateFormatter = /** @class */ (function (_super) {
    __extends(DateFormatter, _super);
    function DateFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dateStyle = DateFormatterStyle.ShortStyle;
        _this.timeStyle = DateFormatterStyle.ShortStyle;
        _this.browserDateSeparatorSymbol = null;
        return _this;
    }
    DateFormatter.prototype.init = function () {
        _super.prototype.init.call(this);
        var browser = (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetPlatform)();
        if (browser == mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCorePlatformType.Safari)
            this.browserDateSeparatorSymbol = "/";
        else
            this.browserDateSeparatorSymbol = "-";
    };
    DateFormatter.prototype.dateFromString = function (str) {
        var _a;
        var result, value, dateString;
        if (!str || str.length <= 0)
            return null;
        _a = this._parse(str), result = _a[0], value = _a[1], dateString = _a[2];
        if (result == true) {
            var date = Date.parse(dateString);
            return isNaN(date) == false ? new Date(dateString) : null;
        }
        return null;
    };
    DateFormatter.prototype.stringFromDate = function (date) {
        return this.stringForObjectValue(date);
    };
    DateFormatter.prototype.stringForObjectValue = function (value) {
        var date = value;
        if (date == null)
            return null;
        var str = "";
        switch (this.dateStyle) {
            case DateFormatterStyle.ShortStyle:
                str = this._shortDateStyle(date);
                break;
            case DateFormatterStyle.FullStyle:
                str = this._fullDateStyle(date);
                break;
        }
        if (this.dateStyle != DateFormatterStyle.NoStyle && this.timeStyle != DateFormatterStyle.NoStyle)
            str += " ";
        switch (this.timeStyle) {
            case DateFormatterStyle.ShortStyle:
                str += this._shortTimeStyle(date);
                break;
        }
        return str;
    };
    DateFormatter.prototype.isPartialStringValid = function (str) {
        var _a;
        if (str.length == 0)
            return [true, str];
        var result, newStr;
        _a = this._parse(str), result = _a[0], newStr = _a[1];
        return [result, newStr];
    };
    DateFormatter.prototype._parse = function (str) {
        var _a, _b;
        var result, newStr, value, offset;
        var dateString = "";
        if (this.dateStyle != DateFormatterStyle.NoStyle) {
            _a = this._parseDate(str), result = _a[0], newStr = _a[1], value = _a[2], offset = _a[3];
            if (result == false)
                return [result, newStr, value];
            dateString = value;
        }
        else {
            var today = new Date();
            dateString = this.iso8601DateStyle(today);
        }
        if (this.timeStyle != DateFormatterStyle.NoStyle) {
            var timeString = str;
            if (offset > 0)
                timeString = str.substr(offset, str.length - offset);
            _b = this._parseTime(timeString), result = _b[0], newStr = _b[1], value = _b[2];
            if (result == false) {
                return [result, newStr, value];
            }
            dateString += " " + value;
        }
        return [result, newStr, dateString];
    };
    DateFormatter.prototype._parseDate = function (str) {
        var _a, _b, _c;
        var chIndex = 0;
        var parseString = "";
        var step = 0;
        var dd = "";
        var mm = "";
        var yy = "";
        // Check dd-mm-yy or dd-mm-yyyy
        for (var index = 0; index < str.length; index++) {
            var ch = str[index];
            chIndex++;
            if (ch == "-" || ch == "." || ch == "/") {
                // Next step
                if (parseString.length == 0)
                    return [false, parseString, "", chIndex];
                parseString += "/";
                step++;
            }
            else if (ch == " ") {
                break;
            }
            else {
                var r = void 0, value = void 0;
                switch (step) {
                    case 0: //dd
                        _a = this._parseDay(ch, dd), r = _a[0], dd = _a[1];
                        break;
                    case 1: // mm                        
                        _b = this._parseMonth(ch, mm), r = _b[0], mm = _b[1];
                        break;
                    case 2: // yy or yyyy
                        _c = this._parseYear(ch, yy), r = _c[0], yy = _c[1];
                        break;
                }
                if (r == true)
                    parseString += ch;
                else
                    return [false, parseString, "", chIndex];
            }
        }
        var result = true;
        if (dd.length > 0)
            result = result && this._validateDay(dd);
        if (mm.length > 0)
            result = result && this._validateMonth(mm);
        if (yy.length > 0)
            result = result && this._validateYear(yy);
        if (result == false)
            return [false, parseString, null, chIndex];
        var dateString = (yy[3] ? yy : ("20" + yy)) + this.browserDateSeparatorSymbol + (mm[1] ? mm : "0" + mm) + this.browserDateSeparatorSymbol + (dd[1] ? dd : "0" + dd);
        return [true, parseString, dateString, chIndex];
    };
    DateFormatter.prototype._parseDay = function (ch, dd) {
        var c = parseInt(ch);
        if (isNaN(c))
            return [false, dd];
        var v = parseInt(dd + ch);
        return [true, dd + ch];
    };
    DateFormatter.prototype._validateDay = function (dd) {
        var v = parseInt(dd);
        if (isNaN(v))
            return false;
        if (dd < 1 || dd > 31)
            return false;
        return true;
    };
    DateFormatter.prototype._parseMonth = function (ch, mm) {
        var c = parseInt(ch);
        if (isNaN(c))
            return [false, mm];
        var v = parseInt(mm + ch);
        return [true, mm + ch];
    };
    DateFormatter.prototype._validateMonth = function (mm) {
        var v = parseInt(mm);
        if (isNaN(v))
            return false;
        if (v < 1 || v > 12)
            return false;
        return true;
    };
    DateFormatter.prototype._parseYear = function (ch, yy) {
        var c = parseInt(ch);
        if (isNaN(c))
            return [false, yy];
        var v = parseInt(yy + ch);
        return [true, yy + ch];
    };
    DateFormatter.prototype._validateYear = function (yy) {
        var v = parseInt(yy);
        if (isNaN(yy) == true)
            return false;
        if (v > 3000)
            return false;
        return true;
    };
    DateFormatter.prototype.iso8601DateStyle = function (date) {
        var dd = date.getDate().toString();
        var mm = (date.getMonth() + 1).toString();
        var yy = date.getFullYear().toString();
        return yy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]);
    };
    DateFormatter.prototype._shortDateStyle = function (date, separatorString) {
        var separator = separatorString ? separatorString : "/";
        var d = date.getDate().toString();
        var m = (date.getMonth() + 1).toString();
        var y = date.getFullYear().toString();
        return (d[1] ? d : 0 + d) + separator + (m[1] ? m : "0" + m) + separator + y;
    };
    DateFormatter.prototype._fullDateStyle = function (date) {
        var day = _NSDateFormatterStringDays[date.getDay()];
        var month = _NSDateFormatterStringMonths[date.getMonth()];
        return day + ", " + month + " " + date.getDate() + ", " + date.getFullYear();
    };
    DateFormatter.prototype._parseTime = function (str) {
        var _a, _b, _c;
        var parseString = "";
        var step = 0;
        var hh = "";
        var mm = "";
        var ss = "";
        // Check dd-mm-yy or dd-mm-yyyy
        for (var index = 0; index < str.length; index++) {
            var ch = str[index];
            if (ch == ":" || ch == ".") {
                // Next step
                if (parseString.length == 0)
                    return [false, parseString, ""];
                parseString += ":";
                step++;
            }
            else {
                var result = void 0, value = void 0;
                switch (step) {
                    case 0: //hh
                        _a = this._parseHour(ch, hh), result = _a[0], hh = _a[1];
                        break;
                    case 1: // mm
                        _b = this._parseMinute(ch, mm), result = _b[0], mm = _b[1];
                        break;
                    case 2: // ss
                        _c = this._parseSecond(ch, ss), result = _c[0], ss = _c[1];
                        break;
                }
                if (result == true)
                    parseString += ch;
                else
                    return [false, parseString, ""];
            }
        }
        var hourString = (hh[1] ? hh : ("0" + hh));
        if (mm.length > 0)
            hourString += ":" + (mm[1] ? mm : ("0" + mm));
        else
            hourString += ":00";
        if (ss.length > 0)
            hourString += ":" + (ss[1] ? ss : ("0" + ss));
        else
            hourString += ":00";
        return [true, parseString, hourString];
    };
    DateFormatter.prototype._parseHour = function (ch, hh) {
        var c = parseInt(ch);
        if (isNaN(c))
            return [false, hh];
        var v = parseInt(hh + ch);
        if (v < 0 || v > 23)
            return [false, hh];
        return [true, hh + ch];
    };
    DateFormatter.prototype._parseMinute = function (ch, mm) {
        var c = parseInt(ch);
        if (isNaN(c))
            return [false, mm];
        var v = parseInt(mm + ch);
        if (v < 0 || v > 59)
            return [false, mm];
        return [true, mm + ch];
    };
    DateFormatter.prototype._parseSecond = function (ch, ss) {
        var c = parseInt(ch);
        if (isNaN(c))
            return [false, ss];
        var v = parseInt(ss + ch);
        if (v < 0 || v > 59)
            return [false, ss];
        return [true, ss + ch];
    };
    DateFormatter.prototype.iso8601TimeStyle = function (date) {
        var hh = date.getHours().toString();
        var mm = date.getMinutes().toString();
        var ss = date.getSeconds().toString();
        return (hh[1] ? hh : "0" + hh[0]) + ":" + (mm[1] ? mm : "0" + mm[0]) + ":" + (ss[1] ? ss : "0" + ss[0]);
    };
    DateFormatter.prototype._shortTimeStyle = function (date) {
        var h = date.getHours().toString();
        var m = date.getMinutes().toString();
        return (h[1] ? h : "0" + h) + ":" + (m[1] ? m : "0" + m);
    };
    return DateFormatter;
}(_Formatter__WEBPACK_IMPORTED_MODULE_1__.Formatter));

var _NSDateFormatterStringDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var _NSDateFormatterStringMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];


/***/ }),

/***/ "./sources/DecimalNumber.ts":
/*!**********************************!*\
  !*** ./sources/DecimalNumber.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSDecimalNumber: () => (/* binding */ NSDecimalNumber)
/* harmony export */ });
/* harmony import */ var _NSNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSNumber */ "./sources/NSNumber.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NSDecimalNumber = /** @class */ (function (_super) {
    __extends(NSDecimalNumber, _super);
    function NSDecimalNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NSDecimalNumber.decimalNumberWithString = function (str) {
        var dn = new NSDecimalNumber();
        dn.initWithString(str);
        return dn;
    };
    NSDecimalNumber.one = function () {
        return NSDecimalNumber.numberWithInteger(1);
    };
    NSDecimalNumber.zero = function () {
        return NSDecimalNumber.numberWithInteger(0);
    };
    // static subclasses from NSnumber
    NSDecimalNumber.numberWithBool = function (value) {
        var n = new NSDecimalNumber();
        n._initWithValue(value);
        return n;
    };
    NSDecimalNumber.numberWithInteger = function (value) {
        var n = new NSDecimalNumber();
        n._initWithValue(value);
        return n;
    };
    NSDecimalNumber.numberWithFloat = function (value) {
        var n = new NSDecimalNumber();
        n._initWithValue(value);
        return n;
    };
    NSDecimalNumber.prototype.initWithString = function (str) {
        this._initWithValue(str);
    };
    NSDecimalNumber.prototype.initWithDecimal = function (value) {
        _super.prototype.init.call(this);
        if (isNaN(value) || value == null) {
            this.storeValue = new Decimal(0);
        }
        else {
            this.storeValue = value;
        }
    };
    NSDecimalNumber.prototype._initWithValue = function (value) {
        _super.prototype.init.call(this);
        this.storeValue = new Decimal(value || 0);
    };
    NSDecimalNumber.prototype.decimalNumberByAdding = function (value) {
        var dv = new NSDecimalNumber();
        dv.initWithDecimal(this.storeValue.add(value.storeValue));
        return dv;
    };
    NSDecimalNumber.prototype.decimalNumberBySubtracting = function (value) {
        var dv = new NSDecimalNumber();
        dv.initWithDecimal(this.storeValue.sub(value.storeValue));
        return dv;
    };
    NSDecimalNumber.prototype.decimalNumberByMultiplyingBy = function (value) {
        var dv = new NSDecimalNumber();
        dv.initWithDecimal(this.storeValue.mul(value.storeValue));
        return dv;
    };
    NSDecimalNumber.prototype.decimalNumberByDividingBy = function (value) {
        var dv = new NSDecimalNumber();
        dv.initWithDecimal(this.storeValue.div(value.storeValue));
        return dv;
    };
    Object.defineProperty(NSDecimalNumber.prototype, "decimalValue", {
        get: function () {
            return this.storeValue.toNumber();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NSDecimalNumber.prototype, "floatValue", {
        get: function () {
            return this.storeValue.toNumber();
        },
        enumerable: false,
        configurable: true
    });
    return NSDecimalNumber;
}(_NSNumber__WEBPACK_IMPORTED_MODULE_0__.NSNumber));



/***/ }),

/***/ "./sources/Error.ts":
/*!**************************!*\
  !*** ./sources/Error.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Error: () => (/* binding */ Error)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Error = /** @class */ (function (_super) {
    __extends(Error, _super);
    function Error() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorCode = 0;
        return _this;
    }
    return Error;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/Formatter.ts":
/*!******************************!*\
  !*** ./sources/Formatter.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Formatter: () => (/* binding */ Formatter)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Formatter = /** @class */ (function (_super) {
    __extends(Formatter, _super);
    function Formatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Formatter.prototype.stringForObjectValue = function (value) {
        return value;
    };
    Formatter.prototype.getObjectValueForString = function (str) {
    };
    Formatter.prototype.editingStringForObjectValue = function (value) {
    };
    Formatter.prototype.isPartialStringValid = function (str) {
        var newStr = "";
        return [false, newStr];
    };
    return Formatter;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/ISO8601DateFormatter.ts":
/*!*****************************************!*\
  !*** ./sources/ISO8601DateFormatter.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ISO8601DateFormatter: () => (/* binding */ ISO8601DateFormatter)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _DateFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DateFormatter */ "./sources/DateFormatter.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ISO8601DateFormatter = /** @class */ (function (_super) {
    __extends(ISO8601DateFormatter, _super);
    function ISO8601DateFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeZone = null;
        return _this;
    }
    ISO8601DateFormatter.iso8601DateFormatter = function () {
        var df = new ISO8601DateFormatter();
        df.init();
        return df;
    };
    ISO8601DateFormatter.prototype.dateFromString = function (str) {
        if (str == null)
            return null;
        var dateString = null;
        if ((0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreGetPlatform)() == mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCorePlatformType.Safari) {
            dateString = str.split('-').join("/");
            if (dateString.length > 19)
                dateString = dateString.substr(0, 19);
        }
        else
            dateString = str;
        var timestamp = Date.parse(dateString);
        var d = null;
        if (isNaN(timestamp) == false) {
            d = new Date(dateString);
        }
        else {
            console.log("DATE FORMATTER: Error, invalid date");
        }
        return d;
    };
    ISO8601DateFormatter.prototype.stringFromDate = function (date) {
        var str = "";
        if (date == null)
            return null;
        if (this.dateStyle != _DateFormatter__WEBPACK_IMPORTED_MODULE_1__.DateFormatterStyle.NoStyle) {
            str += this.iso8601DateStyle(date);
        }
        if (this.timeStyle != _DateFormatter__WEBPACK_IMPORTED_MODULE_1__.DateFormatterStyle.NoStyle) {
            if (str.length > 0)
                str += " ";
            str += this.iso8601TimeStyle(date);
        }
        return str;
    };
    return ISO8601DateFormatter;
}(_DateFormatter__WEBPACK_IMPORTED_MODULE_1__.DateFormatter));



/***/ }),

/***/ "./sources/IndexPath.ts":
/*!******************************!*\
  !*** ./sources/IndexPath.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IndexPath: () => (/* binding */ IndexPath)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

function IndexPathEqual(indexPath1, indexPath2) {
    //TODO: CHECK REAL INDEX PATH
    if (indexPath1 == null || indexPath2 == null)
        return false;
    if (indexPath1.section == indexPath2.section
        && indexPath1.row == indexPath2.row) {
        return true;
    }
    return false;
}
var IndexPath = /** @class */ (function (_super) {
    __extends(IndexPath, _super);
    function IndexPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.indexes = [];
        return _this;
    }
    //FIXME: Remove the data type in the maethod name
    IndexPath.indexForRowIntInSectionInt = function (row, section) {
        IndexPath.indexForRowInSection(row, section);
    };
    IndexPath.indexForRowInSection = function (row, section) {
        var ip = new IndexPath();
        ip.add(section);
        ip.add(row);
        return ip;
    };
    IndexPath.indexForColumnInRowAndSection = function (column, row, section) {
        var ip = IndexPath.indexForRowInSection(row, section);
        ip.add(column);
        return ip;
    };
    IndexPath.prototype.initRowIntSectionInt = function (row, section) {
        this.add(section);
        this.add(row);
    };
    IndexPath.prototype.add = function (value) {
        this.indexes.push(value);
    };
    Object.defineProperty(IndexPath.prototype, "section", {
        get: function () {
            return this.indexes[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexPath.prototype, "row", {
        get: function () {
            return this.indexes[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexPath.prototype, "item", {
        get: function () {
            return this.indexes[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexPath.prototype, "column", {
        get: function () {
            return this.indexes[2];
        },
        enumerable: false,
        configurable: true
    });
    IndexPath.prototype.isEqualToIndexPath = function (indexPath) {
        return IndexPathEqual(this, indexPath);
    };
    return IndexPath;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/KeyedUnarchiver.ts":
/*!************************************!*\
  !*** ./sources/KeyedUnarchiver.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSKeyedUnarchiver: () => (/* binding */ NSKeyedUnarchiver)
/* harmony export */ });
/* harmony import */ var _NSClassFromString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSClassFromString */ "./sources/NSClassFromString.ts");
/* harmony import */ var _NSCoder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NSCoder */ "./sources/NSCoder.ts");
/* harmony import */ var _PropertyListSerialization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PropertyListSerialization */ "./sources/PropertyListSerialization.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var NSKeyedUnarchiver = /** @class */ (function (_super) {
    __extends(NSKeyedUnarchiver, _super);
    function NSKeyedUnarchiver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objects = null;
        _this.currentInfo = null;
        return _this;
    }
    NSKeyedUnarchiver.unarchiveTopLevelObjectWithData = function (data) {
        var coder = new NSKeyedUnarchiver();
        coder.init();
        return coder._parseData(data, null);
    };
    NSKeyedUnarchiver.prototype._parseData = function (data, error) {
        var items = _PropertyListSerialization__WEBPACK_IMPORTED_MODULE_2__.PropertyListSerialization.propertyListWithData(data, 0, 0, null);
        this.objects = items["$objects"];
        var rootIndex = items["$top"]["$0"]["CF$UID"];
        var rootInfo = this.objects[rootIndex];
        var obj = this.createObjectFromInfo(rootInfo);
        return obj;
    };
    NSKeyedUnarchiver.prototype.classFromInfo = function (info) {
        var name = info["$classname"];
        if (name == null) {
            var index = info["$class"]["CF$UID"];
            var objInfo = this.objects[index];
            name = this.classFromInfo(objInfo);
        }
        return name;
    };
    NSKeyedUnarchiver.prototype.createObjectFromInfo = function (info) {
        var classname = this.classFromInfo(info);
        switch (classname) {
            case "NSMutableArray":
            case "NSArray":
                return this.createArray(info);
            case "NSMutableDictionary":
            case "NSDictionary":
                return this.createDictionary(info);
            default:
                return this.createObject(classname, info);
        }
    };
    NSKeyedUnarchiver.prototype.createObject = function (classname, info) {
        var obj = (0,_NSClassFromString__WEBPACK_IMPORTED_MODULE_0__.NSClassFromString)(classname);
        this.currentInfo = info;
        obj.initWithCoder(this);
        this.currentInfo = null;
        return obj;
    };
    NSKeyedUnarchiver.prototype.decodeObjectForKey = function (key) {
        var obj = this.valueFromInfo(this.currentInfo[key]);
        return obj;
    };
    NSKeyedUnarchiver.prototype.createArray = function (info) {
        var objects = info["NS.objects"];
        var array = [];
        for (var index = 0; index < objects.length; index++) {
            var value = this.valueFromInfo(objects[index]);
            array.push(value);
        }
        return array;
    };
    NSKeyedUnarchiver.prototype.createDictionary = function (info) {
        var keys = info["NS.keys"];
        var objects = info["NS.objects"];
        var dict = {};
        for (var index = 0; index < keys.length; index++) {
            // let k = this.valueFromInfo(keys[index]);
            var k = keys[index];
            var v = this.valueFromInfo(objects[index]);
            dict[k] = v;
        }
        return dict;
    };
    NSKeyedUnarchiver.prototype.valueFromInfo = function (info) {
        var index = info["CF$UID"];
        var value = this.objects[index];
        if (typeof value === "boolean")
            return value;
        if (typeof value === "number")
            return value;
        if (typeof value === "string" && value != "$null")
            return value;
        if (typeof value === "string" && value == "$null")
            return null;
        //TODO: Check for date
        return this.createObjectFromInfo(value);
    };
    return NSKeyedUnarchiver;
}(_NSCoder__WEBPACK_IMPORTED_MODULE_1__.NSCoder));



/***/ }),

/***/ "./sources/Locale.ts":
/*!***************************!*\
  !*** ./sources/Locale.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Locale: () => (/* binding */ Locale)
/* harmony export */ });
/* harmony import */ var _Calendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Calendar */ "./sources/Calendar.ts");
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/**
 * Created by godshadow on 30/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var _NS_currentLocale;
var Locale = /** @class */ (function (_super) {
    __extends(Locale, _super);
    function Locale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.language = "es";
        _this.region = "ES";
        _this._calendar = null;
        return _this;
    }
    Locale.currentLocale = function () {
        if (_NS_currentLocale == null) {
            _NS_currentLocale = new Locale();
            _NS_currentLocale.initIdentifierString("es_ES");
        }
        //return NSWebApplication.sharedInstance().currentLanguage;
        return _NS_currentLocale;
    };
    Locale._setCurrentLocale = function (localeIdentifier) {
        _NS_currentLocale = new Locale();
        _NS_currentLocale.initIdentifierString(localeIdentifier);
    };
    Locale.prototype.initIdentifierString = function (identifer) {
        var array = identifer.split("_");
        if (array.length == 1) {
            this.language = array[0];
        }
        else if (array.length == 2) {
            this.language = array[0];
            this.region = array[1];
        }
    };
    Object.defineProperty(Locale.prototype, "decimalSeparator", {
        get: function () {
            var ds = "";
            switch (this.region) {
                case "ES":
                    ds = ",";
                    break;
                case "US":
                    ds = ".";
                    break;
                case "UK":
                    ds = ".";
                    break;
                case "AE":
                    ds = ".";
                    break;
            }
            return ds;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "currencySymbol", {
        get: function () {
            var cs = "";
            switch (this.region) {
                case "ES":
                case "DE":
                case "FR":
                case "IT":
                case "NL":
                    cs = "€";
                    break;
                case "US":
                    cs = "$";
                    break;
                case "UK":
                    cs = "£";
                    break;
            }
            return cs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "currencyCode", {
        get: function () {
            var cc = "";
            switch (this.region) {
                case "ES":
                case "DE":
                case "FR":
                case "IT":
                case "NL":
                    cc = "EUR";
                    break;
                case "US":
                    cc = "USD";
                    break;
                case "UK":
                    cc = "GBP";
                    break;
                case "AE":
                    cc = "AED";
            }
            return cc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "groupingSeparator", {
        get: function () {
            var gs = "";
            switch (this.region) {
                case "ES":
                    gs = ".";
                    break;
                case "US":
                    gs = ",";
                    break;
                case "UK":
                    gs = ",";
                    break;
                case "AE":
                    gs = ",";
                    break;
            }
            return gs;
        },
        enumerable: false,
        configurable: true
    });
    Locale.prototype.firstWeekday = function () {
        return this.calendar.firstWeekday();
    };
    Object.defineProperty(Locale.prototype, "calendar", {
        get: function () {
            if (this._calendar != null)
                return this._calendar;
            this._calendar = new _Calendar__WEBPACK_IMPORTED_MODULE_0__.Calendar();
            this._calendar.init();
            return this._calendar;
        },
        enumerable: false,
        configurable: true
    });
    return Locale;
}(_NSObject__WEBPACK_IMPORTED_MODULE_1__.NSObject));



/***/ }),

/***/ "./sources/NSClassFromString.ts":
/*!**************************************!*\
  !*** ./sources/NSClassFromString.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSClassFromString: () => (/* binding */ NSClassFromString)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);

function NSClassFromString(className) {
    var classObject = (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreClassByName)(className);
    if (classObject == null)
        throw new Error("NSClassFromString: class '" + className + "' didn't register.");
    var newClass = new classObject();
    // if((newClass as any).init$vars) (newClass as any).init$vars()//quick fix for transpiler because it needs it
    newClass._className = className;
    return newClass;
}


/***/ }),

/***/ "./sources/NSCoder.ts":
/*!****************************!*\
  !*** ./sources/NSCoder.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSCoder: () => (/* binding */ NSCoder)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NSCoder = /** @class */ (function (_super) {
    __extends(NSCoder, _super);
    function NSCoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NSCoder.prototype.encodeObject = function (object) { };
    NSCoder.prototype.decodeObject = function () { };
    NSCoder.prototype.decodeBoolForKey = function (key) { };
    NSCoder.prototype.decodeIntegerForKey = function (key) { };
    NSCoder.prototype.decodeObjectForKey = function (key) { };
    return NSCoder;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/NSLog.ts":
/*!**************************!*\
  !*** ./sources/NSLog.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSLog: () => (/* binding */ NSLog)
/* harmony export */ });
function NSLog(format) {
    console.log(format);
}


/***/ }),

/***/ "./sources/NSNull.ts":
/*!***************************!*\
  !*** ./sources/NSNull.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSNull: () => (/* binding */ NSNull)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NSNull = /** @class */ (function (_super) {
    __extends(NSNull, _super);
    function NSNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NSNull.nullValue = function () {
        var n = new NSNull();
        n.init();
        return n;
    };
    return NSNull;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/NSNumber.ts":
/*!*****************************!*\
  !*** ./sources/NSNumber.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSNumber: () => (/* binding */ NSNumber)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NSNumber = /** @class */ (function (_super) {
    __extends(NSNumber, _super);
    function NSNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NSNumber.numberWithBool = function (value) {
        var n = new NSNumber();
        n.initWithBool(value);
        return n;
    };
    NSNumber.numberWithInteger = function (value) {
        var n = new NSNumber();
        n.initValueInt(value);
        return n;
    };
    NSNumber.numberWithFloat = function (value) {
        var n = new NSNumber();
        n.initWithFloat(value);
        return n;
    };
    NSNumber.prototype.initWithBool = function (value) {
        if (isNaN(value) || value == null) {
            this.storeValue = 1;
        }
        else {
            this.storeValue = value ? 0 : 1;
        }
    };
    NSNumber.prototype.initValueInt = function (value) {
        if (isNaN(value) || value == null) {
            this.storeValue = 0;
        }
        else {
            this.storeValue = value;
        }
    };
    NSNumber.prototype.initWithFloat = function (value) {
        if (isNaN(value) || value == null) {
            this.storeValue = 0.0;
        }
        else {
            this.storeValue = value;
        }
    };
    Object.defineProperty(NSNumber.prototype, "floatValue", {
        get: function () {
            return this.storeValue;
        },
        enumerable: false,
        configurable: true
    });
    return NSNumber;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/NSObject.ts":
/*!*****************************!*\
  !*** ./sources/NSObject.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSObject: () => (/* binding */ NSObject)
/* harmony export */ });
/* harmony import */ var _NSClassFromString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSClassFromString */ "./sources/NSClassFromString.ts");
/**
 * Created by godshadow on 26/3/16.
 */

var NSObject = /** @class */ (function () {
    function NSObject() {
        this._className = null;
        this.keyPaths = {};
    }
    NSObject.prototype.getClassName = function () {
        if (this._className != null)
            return this._className;
        this._className = this.constructor["name"];
        // let funcNameRegex = /function (.{1,})\(/;
        // let results = (funcNameRegex).exec((this).constructor.toString());        
        // this._className = (results && results.length > 1) ? results[1] : null;
        return this._className;
    };
    Object.defineProperty(NSObject.prototype, "className", {
        get: function () {
            return this.getClassName();
        },
        enumerable: false,
        configurable: true
    });
    NSObject.prototype.init = function () { };
    NSObject.prototype.initWithCoder = function (coder) { };
    NSObject.prototype._notifyValueChange = function (key, type) {
        var observers = this.keyPaths[key];
        if (observers == null)
            return;
        // copy the array so we can iterating safetly
        var obs = [];
        for (var count = 0; count < observers.length; count++) {
            var item = observers[count];
            obs.push(item);
        }
        for (var count = 0; count < obs.length; count++) {
            var item = obs[count];
            var o = item["OBS"];
            if (typeof o.observeValueForKeyPath === "function") {
                var keyPath = item["KP"] != null ? item["KP"] : key;
                var ctx = item["CTX"];
                o.observeValueForKeyPath.call(o, keyPath, type, this, ctx);
            }
        }
    };
    NSObject.prototype.willChangeValueForKey = function (key) {
        this.willChangeValue(key);
    };
    NSObject.prototype.didChangeValueForKey = function (key) {
        this.didChangeValue(key);
    };
    //TODO: Remove below method
    NSObject.prototype.willChangeValue = function (key) {
        this._notifyValueChange(key, "will");
    };
    NSObject.prototype.didChangeValue = function (key) {
        this._notifyValueChange(key, "did");
    };
    NSObject.prototype._addObserver = function (obs, key, context, keyPath) {
        var observers = this.keyPaths[key];
        if (observers == null) {
            observers = [];
            this.keyPaths[key] = observers;
        }
        var item = { "OBS": obs };
        if (context != null)
            item["CTX"] = context;
        if (keyPath != null)
            item["KP"] = keyPath;
        observers.push(item);
    };
    NSObject.prototype._keyFromKeypath = function (keypath) {
        var index = keypath.indexOf('.');
        if (index == -1) {
            return [keypath, null];
        }
        var key = keypath.substring(0, index);
        var offset = keypath.substring(index + 1);
        return [key, offset];
    };
    NSObject.prototype.addObserver = function (obs, keypath, context) {
        var _a;
        var _b = this._keyFromKeypath(keypath), key = _b[0], offset = _b[1];
        if (offset == null) {
            this._addObserver(obs, key, context);
        }
        else {
            var obj = this;
            var exit = false;
            while (exit == false) {
                if (offset == null) {
                    obj._addObserver(obs, key, context, keypath);
                    exit = true;
                }
                else {
                    obj = this.valueForKey(key);
                    _a = this._keyFromKeypath(offset), key = _a[0], offset = _a[1];
                }
                if (obj == null)
                    throw new Error("ERROR: Registering observer to null object");
            }
        }
    };
    NSObject.prototype.removeObserver = function (obs, keypath) {
        var observers = this.keyPaths[keypath];
        if (observers == null)
            return;
        var index = observers.indexOf(obs);
        observers.splice(index, 1);
    };
    NSObject.prototype.setValueForKey = function (value, key) {
        this.willChangeValue(key);
        this[key] = value;
        this.didChangeValue(value);
    };
    NSObject.prototype.valueForKey = function (key) {
        return this[key];
    };
    NSObject.prototype.valueForKeyPath = function (keyPath) {
        var _a;
        var _b = this._keyFromKeypath(keyPath), key = _b[0], offset = _b[1];
        var value = null;
        var obj = this;
        var exit = false;
        while (exit == false) {
            if (offset == null) {
                value = obj.valueForKey(key);
                exit = true;
            }
            else {
                obj = obj.valueForKey(key);
                _a = this._keyFromKeypath(offset), key = _a[0], offset = _a[1];
                if (obj == null)
                    exit = true;
            }
        }
        return value;
    };
    NSObject.prototype.copy = function () {
        var obj = (0,_NSClassFromString__WEBPACK_IMPORTED_MODULE_0__.NSClassFromString)(this.className);
        obj.init();
        return obj;
    };
    NSObject.prototype.performSelector = function (selector) {
        return this[selector]();
    };
    NSObject.prototype.performSelectorOnMainThread = function (selector, arg, waitUntilDone) {
        this[selector](arg);
    };
    return NSObject;
}());



/***/ }),

/***/ "./sources/NSPredicate.ts":
/*!********************************!*\
  !*** ./sources/NSPredicate.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSPredicate: () => (/* binding */ NSPredicate),
/* harmony export */   NSPredicateBitwiseOperatorType: () => (/* binding */ NSPredicateBitwiseOperatorType),
/* harmony export */   NSPredicateComparatorType: () => (/* binding */ NSPredicateComparatorType),
/* harmony export */   NSPredicateGroup: () => (/* binding */ NSPredicateGroup),
/* harmony export */   NSPredicateItem: () => (/* binding */ NSPredicateItem),
/* harmony export */   NSPredicateItemValueType: () => (/* binding */ NSPredicateItemValueType),
/* harmony export */   NSPredicateOperator: () => (/* binding */ NSPredicateOperator),
/* harmony export */   NSPredicateOperatorType: () => (/* binding */ NSPredicateOperatorType),
/* harmony export */   NSPredicateRelationshipOperatorType: () => (/* binding */ NSPredicateRelationshipOperatorType),
/* harmony export */   NSPredicateType: () => (/* binding */ NSPredicateType),
/* harmony export */   _NSPredicateFilterObjects: () => (/* binding */ _NSPredicateFilterObjects)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ISO8601DateFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ISO8601DateFormatter */ "./sources/ISO8601DateFormatter.ts");
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/**
 * Created by godshadow on 1/5/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var NSPredicateComparatorType;
(function (NSPredicateComparatorType) {
    NSPredicateComparatorType[NSPredicateComparatorType["Equal"] = 0] = "Equal";
    NSPredicateComparatorType[NSPredicateComparatorType["Less"] = 1] = "Less";
    NSPredicateComparatorType[NSPredicateComparatorType["LessOrEqual"] = 2] = "LessOrEqual";
    NSPredicateComparatorType[NSPredicateComparatorType["Greater"] = 3] = "Greater";
    NSPredicateComparatorType[NSPredicateComparatorType["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    NSPredicateComparatorType[NSPredicateComparatorType["Distinct"] = 5] = "Distinct";
    NSPredicateComparatorType[NSPredicateComparatorType["Contains"] = 6] = "Contains";
    NSPredicateComparatorType[NSPredicateComparatorType["NotContains"] = 7] = "NotContains";
    NSPredicateComparatorType[NSPredicateComparatorType["In"] = 8] = "In";
    NSPredicateComparatorType[NSPredicateComparatorType["NotIn"] = 9] = "NotIn";
})(NSPredicateComparatorType || (NSPredicateComparatorType = {}));
var NSPredicateRelationshipOperatorType;
(function (NSPredicateRelationshipOperatorType) {
    NSPredicateRelationshipOperatorType[NSPredicateRelationshipOperatorType["ANY"] = 0] = "ANY";
    NSPredicateRelationshipOperatorType[NSPredicateRelationshipOperatorType["ALL"] = 1] = "ALL";
})(NSPredicateRelationshipOperatorType || (NSPredicateRelationshipOperatorType = {}));
var NSPredicateOperatorType;
(function (NSPredicateOperatorType) {
    NSPredicateOperatorType[NSPredicateOperatorType["OR"] = 0] = "OR";
    NSPredicateOperatorType[NSPredicateOperatorType["AND"] = 1] = "AND";
})(NSPredicateOperatorType || (NSPredicateOperatorType = {}));
var NSPredicateBitwiseOperatorType;
(function (NSPredicateBitwiseOperatorType) {
    NSPredicateBitwiseOperatorType[NSPredicateBitwiseOperatorType["OR"] = 0] = "OR";
    NSPredicateBitwiseOperatorType[NSPredicateBitwiseOperatorType["AND"] = 1] = "AND";
    NSPredicateBitwiseOperatorType[NSPredicateBitwiseOperatorType["XOR"] = 2] = "XOR";
})(NSPredicateBitwiseOperatorType || (NSPredicateBitwiseOperatorType = {}));
var NSPredicateType;
(function (NSPredicateType) {
    NSPredicateType[NSPredicateType["Predicate"] = 0] = "Predicate";
    NSPredicateType[NSPredicateType["Item"] = 1] = "Item";
    NSPredicateType[NSPredicateType["Operation"] = 2] = "Operation";
})(NSPredicateType || (NSPredicateType = {}));
var NSPredicateOperator = /** @class */ (function () {
    function NSPredicateOperator(type) {
        this.type = null;
        this.type = type;
    }
    NSPredicateOperator.andPredicateOperatorType = function () {
        var op = new NSPredicateOperator(NSPredicateOperatorType.AND);
        return op;
    };
    NSPredicateOperator.orPredicateOperatorType = function () {
        var op = new NSPredicateOperator(NSPredicateOperatorType.OR);
        return op;
    };
    return NSPredicateOperator;
}());

var NSPredicateItemValueType;
(function (NSPredicateItemValueType) {
    NSPredicateItemValueType[NSPredicateItemValueType["Undefined"] = 0] = "Undefined";
    NSPredicateItemValueType[NSPredicateItemValueType["UUID"] = 1] = "UUID";
    NSPredicateItemValueType[NSPredicateItemValueType["String"] = 2] = "String";
    NSPredicateItemValueType[NSPredicateItemValueType["Number"] = 3] = "Number";
    NSPredicateItemValueType[NSPredicateItemValueType["Boolean"] = 4] = "Boolean";
    NSPredicateItemValueType[NSPredicateItemValueType["Null"] = 5] = "Null";
    NSPredicateItemValueType[NSPredicateItemValueType["Property"] = 6] = "Property";
})(NSPredicateItemValueType || (NSPredicateItemValueType = {}));
var NSPredicateItem = /** @class */ (function () {
    function NSPredicateItem() {
        this.relationshipOperation = null;
        this.bitwiseOperation = null;
        this.bitwiseKey = null;
        this.bitwiseValue = null;
        this.key = null;
        this.comparator = null;
        this.value = null;
        this.valueType = NSPredicateItemValueType.Undefined;
    }
    NSPredicateItem.prototype.evaluateObject = function (object, key, lvalue) {
        var lValue = lvalue;
        if (lvalue == null) {
            var k = key != null ? key : this.key;
            if (object instanceof _NSObject__WEBPACK_IMPORTED_MODULE_2__.NSObject) {
                lValue = object.valueForKeyPath(k);
            }
            else {
                lValue = object[k];
            }
            if (lValue instanceof Date) {
                var sdf = new _ISO8601DateFormatter__WEBPACK_IMPORTED_MODULE_1__.ISO8601DateFormatter();
                sdf.init();
                lValue = sdf.stringFromDate(lValue);
            }
            else if (typeof lValue === "string") {
                lValue = lValue.toLocaleLowerCase();
            }
        }
        var rValue = this.value;
        if (this.valueType == NSPredicateItemValueType.Property) {
            rValue = object.valueForKeyPath(rValue);
        }
        if (typeof rValue === "string") {
            rValue = rValue.toLocaleLowerCase();
        }
        if (this.comparator == NSPredicateComparatorType.Equal)
            return (lValue == rValue);
        else if (this.comparator == NSPredicateComparatorType.Distinct)
            return (lValue != rValue);
        else if (this.comparator == NSPredicateComparatorType.Less)
            return (lValue < rValue);
        else if (this.comparator == NSPredicateComparatorType.LessOrEqual)
            return (lValue <= rValue);
        else if (this.comparator == NSPredicateComparatorType.Greater)
            return (lValue > rValue);
        else if (this.comparator == NSPredicateComparatorType.GreaterOrEqual)
            return (lValue >= rValue);
        else if (this.comparator == NSPredicateComparatorType.Contains) {
            if (lValue == null)
                return false;
            if (lValue.indexOf(rValue) > -1)
                return true;
            return false;
        }
        else if (this.comparator == NSPredicateComparatorType.NotContains) {
            if (lValue == null)
                return true;
            if (lValue.indexOf(rValue) > -1)
                return false;
            return true;
        }
    };
    NSPredicateItem.prototype.evaluateRelationshipObject = function (object) {
        var relObjs = null;
        var keys = this.key.split('.');
        var lastKey = keys[keys.length - 1];
        if (keys.length > 1) {
            var relKey = this.key.substring(0, this.key.length - lastKey.length - 1);
            relObjs = object.valueForKeyPath(relKey);
        }
        else {
            relObjs = object.valueForKeyPath(this.key);
        }
        for (var index = 0; index < relObjs.count; index++) {
            var o = relObjs.objectAtIndex(index);
            var result = this.evaluateObject(o, lastKey);
            if (result == true && this.relationshipOperation == NSPredicateRelationshipOperatorType.ANY) {
                return true;
            }
            else if (result == false && this.relationshipOperation == NSPredicateRelationshipOperatorType.ALL) {
                return false;
            }
        }
        return false;
    };
    // HACK: Dirty hack to bitwaire comparate more than 32bits    
    NSPredicateItem.prototype.evaluateBitwaseOperatorObject = function (object) {
        var lvalue = object.valueForKeyPath(this.bitwiseKey);
        var rvalue = parseInt(this.bitwiseValue);
        var value = 0;
        if (this.bitwiseOperation == NSPredicateBitwiseOperatorType.AND) {
            value = lvalue & rvalue;
        }
        else if (this.bitwiseOperation == NSPredicateBitwiseOperatorType.OR) {
            value = lvalue | rvalue;
        }
        return this.evaluateObject(object, null, value);
    };
    return NSPredicateItem;
}());

var NSPredicateGroup = /** @class */ (function () {
    function NSPredicateGroup() {
        this.predicates = [];
    }
    NSPredicateGroup.prototype.evaluateObject = function (object) {
        var result = false;
        var op = null;
        var lastResult = null;
        for (var count = 0; count < this.predicates.length; count++) {
            var o = this.predicates[count];
            if (o instanceof NSPredicateGroup) {
                result = o.evaluateObject(object);
            }
            else if (o instanceof NSPredicateItem) {
                if (o.relationshipOperation != null) {
                    result = o.evaluateRelationshipObject(object);
                }
                else if (o.bitwiseOperation != null) {
                    result = o.evaluateBitwaseOperatorObject(object);
                }
                else {
                    result = o.evaluateObject(object);
                }
            }
            else if (o instanceof NSPredicateOperator) {
                op = o.type;
                lastResult = result;
                result = null;
            }
            else {
                throw new Error("NSPredicate: Error. Predicate class type invalid. (".concat(o, ")"));
            }
            if (op != null && result != null) {
                if (op == NSPredicateOperatorType.AND) {
                    result = result && lastResult;
                    op = null;
                    if (result == false)
                        break;
                }
                else if (op == NSPredicateOperatorType.OR) {
                    result = result || lastResult;
                    op = null;
                }
            }
        }
        return result;
    };
    return NSPredicateGroup;
}());

var NSPredicateTokenType;
(function (NSPredicateTokenType) {
    NSPredicateTokenType[NSPredicateTokenType["Identifier"] = 0] = "Identifier";
    NSPredicateTokenType[NSPredicateTokenType["UUIDValue"] = 1] = "UUIDValue";
    NSPredicateTokenType[NSPredicateTokenType["StringValue"] = 2] = "StringValue";
    NSPredicateTokenType[NSPredicateTokenType["NumberValue"] = 3] = "NumberValue";
    NSPredicateTokenType[NSPredicateTokenType["BooleanValue"] = 4] = "BooleanValue";
    NSPredicateTokenType[NSPredicateTokenType["NullValue"] = 5] = "NullValue";
    NSPredicateTokenType[NSPredicateTokenType["PropertyValue"] = 6] = "PropertyValue";
    NSPredicateTokenType[NSPredicateTokenType["MinorOrEqualComparator"] = 7] = "MinorOrEqualComparator";
    NSPredicateTokenType[NSPredicateTokenType["MinorComparator"] = 8] = "MinorComparator";
    NSPredicateTokenType[NSPredicateTokenType["MajorOrEqualComparator"] = 9] = "MajorOrEqualComparator";
    NSPredicateTokenType[NSPredicateTokenType["MajorComparator"] = 10] = "MajorComparator";
    NSPredicateTokenType[NSPredicateTokenType["EqualComparator"] = 11] = "EqualComparator";
    NSPredicateTokenType[NSPredicateTokenType["DistinctComparator"] = 12] = "DistinctComparator";
    NSPredicateTokenType[NSPredicateTokenType["ContainsComparator"] = 13] = "ContainsComparator";
    NSPredicateTokenType[NSPredicateTokenType["NotContainsComparator"] = 14] = "NotContainsComparator";
    NSPredicateTokenType[NSPredicateTokenType["InComparator"] = 15] = "InComparator";
    NSPredicateTokenType[NSPredicateTokenType["NotIntComparator"] = 16] = "NotIntComparator";
    NSPredicateTokenType[NSPredicateTokenType["BitwiseAND"] = 17] = "BitwiseAND";
    NSPredicateTokenType[NSPredicateTokenType["BitwiseOR"] = 18] = "BitwiseOR";
    NSPredicateTokenType[NSPredicateTokenType["OpenParenthesisSymbol"] = 19] = "OpenParenthesisSymbol";
    NSPredicateTokenType[NSPredicateTokenType["CloseParenthesisSymbol"] = 20] = "CloseParenthesisSymbol";
    NSPredicateTokenType[NSPredicateTokenType["Whitespace"] = 21] = "Whitespace";
    NSPredicateTokenType[NSPredicateTokenType["AND"] = 22] = "AND";
    NSPredicateTokenType[NSPredicateTokenType["OR"] = 23] = "OR";
    NSPredicateTokenType[NSPredicateTokenType["ANY"] = 24] = "ANY";
    NSPredicateTokenType[NSPredicateTokenType["ALL"] = 25] = "ALL";
})(NSPredicateTokenType || (NSPredicateTokenType = {}));
var NSPredicate = /** @class */ (function (_super) {
    __extends(NSPredicate, _super);
    function NSPredicate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.predicateGroup = null;
        _this.lexer = null;
        _this._predicateFormat = null;
        return _this;
    }
    NSPredicate.predicateWithFormat = function (format) {
        var p = new NSPredicate();
        p.initWithFormat(format);
        return p;
    };
    NSPredicate.prototype.initWithFormat = function (format) {
        this._predicateFormat = format;
        this.parse(format);
    };
    Object.defineProperty(NSPredicate.prototype, "predicateFormat", {
        get: function () {
            return this._predicateFormat;
        },
        enumerable: false,
        configurable: true
    });
    NSPredicate.prototype.evaluateObject = function (object) {
        return this.predicateGroup.evaluateObject(object);
    };
    // 
    // Parse format string
    //
    NSPredicate.prototype.tokenizeWithFormat = function (format) {
        this.lexer = new mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreLexer(format);
        // Values
        this.lexer.addTokenType(NSPredicateTokenType.UUIDValue, /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
        this.lexer.addTokenType(NSPredicateTokenType.StringValue, /^"([^"]*)"|^'([^']*)'/);
        this.lexer.addTokenType(NSPredicateTokenType.NumberValue, /^-?\d+(?:\.\d+)?(?:e[+\-]?\d+)?/i);
        this.lexer.addTokenType(NSPredicateTokenType.BooleanValue, /^(true|false)/i);
        this.lexer.addTokenType(NSPredicateTokenType.NullValue, /^(null|nil)/i);
        // Symbols
        this.lexer.addTokenType(NSPredicateTokenType.OpenParenthesisSymbol, /^\(/);
        this.lexer.addTokenType(NSPredicateTokenType.CloseParenthesisSymbol, /^\)/);
        // Comparators
        this.lexer.addTokenType(NSPredicateTokenType.MinorOrEqualComparator, /^<=/);
        this.lexer.addTokenType(NSPredicateTokenType.MinorComparator, /^</);
        this.lexer.addTokenType(NSPredicateTokenType.MajorOrEqualComparator, /^>=/);
        this.lexer.addTokenType(NSPredicateTokenType.MajorComparator, /^>/);
        this.lexer.addTokenType(NSPredicateTokenType.EqualComparator, /^==?/);
        this.lexer.addTokenType(NSPredicateTokenType.DistinctComparator, /^!=/);
        this.lexer.addTokenType(NSPredicateTokenType.NotContainsComparator, /^not contains /i);
        this.lexer.addTokenType(NSPredicateTokenType.ContainsComparator, /^contains /i);
        this.lexer.addTokenType(NSPredicateTokenType.InComparator, /^in /i);
        // Bitwise operators
        this.lexer.addTokenType(NSPredicateTokenType.BitwiseAND, /^& /i);
        this.lexer.addTokenType(NSPredicateTokenType.BitwiseOR, /^\| /i);
        // Join operators
        this.lexer.addTokenType(NSPredicateTokenType.AND, /^(and|&&) /i);
        this.lexer.addTokenType(NSPredicateTokenType.OR, /^(or|\|\|) /i);
        // Relationship operators
        this.lexer.addTokenType(NSPredicateTokenType.ANY, /^any /i);
        this.lexer.addTokenType(NSPredicateTokenType.ALL, /^all /i);
        // Extra
        this.lexer.addTokenType(NSPredicateTokenType.Whitespace, /^\s+/);
        this.lexer.ignoreTokenType(NSPredicateTokenType.Whitespace);
        // Identifiers - Has to be the last one
        this.lexer.addTokenType(NSPredicateTokenType.Identifier, /^[a-zA-Z-_][a-zA-Z0-9-_\.]*/);
        this.lexer.tokenize();
    };
    NSPredicate.prototype.parse = function (format) {
        console.log("**** Start predicate format parser");
        console.log(format);
        console.log("****");
        this.tokenizeWithFormat(format);
        this.predicateGroup = new NSPredicateGroup();
        this.predicateGroup.predicates = this.parsePredicates();
        console.log("**** End predicate format parser");
    };
    NSPredicate.prototype.parsePredicates = function () {
        var token = this.lexer.nextToken();
        var predicates = [];
        var exit = false;
        while (token != null && exit == false) {
            switch (token.type) {
                case NSPredicateTokenType.Identifier:
                    var pi = this.nextPredicateItem();
                    predicates.push(pi);
                    break;
                case NSPredicateTokenType.AND:
                    predicates.push(NSPredicateOperator.andPredicateOperatorType());
                    break;
                case NSPredicateTokenType.OR:
                    predicates.push(NSPredicateOperator.orPredicateOperatorType());
                    break;
                case NSPredicateTokenType.ANY:
                    this.lexer.nextToken();
                    var anyPI = this.nextPredicateItem();
                    anyPI.relationshipOperation = NSPredicateRelationshipOperatorType.ANY;
                    predicates.push(anyPI);
                    break;
                case NSPredicateTokenType.ALL:
                    this.lexer.nextToken();
                    var allPI = this.nextPredicateItem();
                    anyPI.relationshipOperation = NSPredicateRelationshipOperatorType.ALL;
                    predicates.push(anyPI);
                    break;
                case NSPredicateTokenType.OpenParenthesisSymbol:
                    var pg = new NSPredicateGroup();
                    pg.predicates = this.parsePredicates();
                    predicates.push(pg);
                    break;
                case NSPredicateTokenType.CloseParenthesisSymbol:
                    exit = true;
                    break;
                default:
                    throw new Error("NSPredicate: Error. Unexpected token. (".concat(token.value, ")"));
            }
            if (exit != true) {
                token = this.lexer.nextToken();
            }
        }
        return predicates;
    };
    NSPredicate.prototype.nextPredicateItem = function () {
        var pi = new NSPredicateItem();
        this.lexer.prevToken();
        this.property(pi);
        this.comparator(pi);
        this.value(pi);
        return pi;
    };
    NSPredicate.prototype.property = function (item) {
        var token = this.lexer.nextToken();
        switch (token.type) {
            case NSPredicateTokenType.Identifier:
                item.key = token.value;
                break;
            default:
                throw new Error("NSPredicate: Error. Unexpected identifier key. (".concat(token.value, ")"));
        }
    };
    NSPredicate.prototype.comparator = function (item) {
        var token = this.lexer.nextToken();
        switch (token.type) {
            case NSPredicateTokenType.EqualComparator:
                item.comparator = NSPredicateComparatorType.Equal;
                break;
            case NSPredicateTokenType.MajorComparator:
                item.comparator = NSPredicateComparatorType.Greater;
                break;
            case NSPredicateTokenType.MajorOrEqualComparator:
                item.comparator = NSPredicateComparatorType.GreaterOrEqual;
                break;
            case NSPredicateTokenType.MinorComparator:
                item.comparator = NSPredicateComparatorType.Less;
                break;
            case NSPredicateTokenType.MinorOrEqualComparator:
                item.comparator = NSPredicateComparatorType.LessOrEqual;
                break;
            case NSPredicateTokenType.DistinctComparator:
                item.comparator = NSPredicateComparatorType.Distinct;
                break;
            case NSPredicateTokenType.ContainsComparator:
                item.comparator = NSPredicateComparatorType.Contains;
                break;
            case NSPredicateTokenType.NotContainsComparator:
                item.comparator = NSPredicateComparatorType.NotContains;
                break;
            case NSPredicateTokenType.InComparator:
                item.comparator = NSPredicateComparatorType.In;
                break;
            case NSPredicateTokenType.BitwiseAND:
                item.bitwiseOperation = NSPredicateBitwiseOperatorType.AND;
                item.bitwiseKey = item.key;
                item.key += " & ";
                token = this.lexer.nextToken();
                item.bitwiseValue = token.value;
                item.key += token.value;
                this.comparator(item);
                break;
            case NSPredicateTokenType.BitwiseOR:
                item.bitwiseOperation = NSPredicateBitwiseOperatorType.OR;
                item.bitwiseKey = item.key;
                item.key += " & ";
                token = this.lexer.nextToken();
                item.bitwiseValue = token.value;
                item.key += token.value;
                this.comparator(item);
                break;
            default:
                throw new Error("NSPredicate: Error. Unexpected comparator. (".concat(token.value, ")"));
        }
    };
    NSPredicate.prototype.value = function (item) {
        var token = this.lexer.nextToken();
        switch (token.type) {
            case NSPredicateTokenType.UUIDValue:
                item.value = token.value;
                item.valueType = NSPredicateItemValueType.UUID;
                break;
            case NSPredicateTokenType.StringValue:
                item.value = token.value.substring(1, token.value.length - 1);
                item.valueType = NSPredicateItemValueType.String;
                break;
            case NSPredicateTokenType.NumberValue:
                item.value = token.value;
                item.valueType = NSPredicateItemValueType.Number;
                break;
            case NSPredicateTokenType.BooleanValue:
                item.value = this.booleanFromString(token.value);
                item.valueType = NSPredicateItemValueType.Boolean;
                break;
            case NSPredicateTokenType.NullValue:
                item.value = this.nullFromString(token.value);
                item.valueType = NSPredicateItemValueType.Null;
                break;
            case NSPredicateTokenType.Identifier:
                item.value = token.value;
                item.valueType = NSPredicateItemValueType.Property;
                break;
            default:
                throw new Error("NSPredicate: Error. Unexpected comparator. (".concat(token.value, ")"));
        }
    };
    NSPredicate.prototype.booleanFromString = function (value) {
        var v = value.toLocaleLowerCase();
        var bv = false;
        switch (v) {
            case "yes":
            case "true":
                bv = true;
                break;
            case "no":
            case "false":
                bv = false;
                break;
            default:
                throw new Error("NSPredicate: Error. Can't convert '".concat(value, "' to boolean"));
        }
        return bv;
    };
    NSPredicate.prototype.nullFromString = function (value) {
        var v = value.toLocaleLowerCase();
        var nv = null;
        switch (v) {
            case "nil":
            case "null":
                nv = null;
                break;
            default:
                throw new Error("NSPredicate: Error. Can't convert '".concat(value, "' to null"));
        }
        return nv;
    };
    return NSPredicate;
}(_NSObject__WEBPACK_IMPORTED_MODULE_2__.NSObject));

//
// For internal purposes: Don't use it, could change
//
function _NSPredicateFilterObjects(objs, predicate) {
    if (objs == null)
        return [];
    var resultObjects = null;
    if (objs.length == 0 || predicate == null) {
        resultObjects = objs.slice(0);
    }
    else {
        resultObjects = objs.filter(function (obj) {
            var result = predicate.evaluateObject(obj);
            if (result)
                return obj;
        });
    }
    return resultObjects;
}


/***/ }),

/***/ "./sources/NSRange.ts":
/*!****************************!*\
  !*** ./sources/NSRange.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSEqualRanges: () => (/* binding */ NSEqualRanges),
/* harmony export */   NSIntersectionRange: () => (/* binding */ NSIntersectionRange),
/* harmony export */   NSLocationInRange: () => (/* binding */ NSLocationInRange),
/* harmony export */   NSMaxRange: () => (/* binding */ NSMaxRange),
/* harmony export */   NSRange: () => (/* binding */ NSRange),
/* harmony export */   NSUnionRange: () => (/* binding */ NSUnionRange)
/* harmony export */ });
var NSRange = /** @class */ (function () {
    function NSRange(location, length) {
        this.location = 0;
        this.length = 0;
        this.location = location;
        this.length = length;
    }
    return NSRange;
}());

function NSMaxRange(range) {
    return range.location + range.length;
}
function NSEqualRanges(range1, range2) {
    return (range1.location == range2.location && range1.length == range2.length);
}
function NSLocationInRange(location, range) {
    if (range == null)
        return false;
    return (location >= range.location && location < NSMaxRange(range)) ? true : false;
}
function NSIntersectionRange(range1, range2) {
    var max1 = NSMaxRange(range1);
    var max2 = NSMaxRange(range2);
    var min, loc;
    var result;
    min = (max1 < max2) ? max1 : max2;
    loc = (range1.location > range2.location) ? range1.location : range2.location;
    if (min < loc) {
        result.location = result.length = 0;
    }
    else {
        result.location = loc;
        result.length = min - loc;
    }
    return result;
}
function NSUnionRange(range1, range2) {
    var max1 = NSMaxRange(range1);
    var max2 = NSMaxRange(range2);
    var max, loc;
    var result;
    max = (max1 > max2) ? max1 : max2;
    loc = (range1.location < range2.location) ? range1.location : range2.location;
    result.location = loc;
    result.length = max - result.location;
    return result;
}


/***/ }),

/***/ "./sources/NSSet.ts":
/*!**************************!*\
  !*** ./sources/NSSet.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSSet: () => (/* binding */ NSSet)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/* harmony import */ var _NSPredicate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NSPredicate */ "./sources/NSPredicate.ts");
/// <reference path="NSPredicate.ts" />
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var NSSet = /** @class */ (function (_super) {
    __extends(NSSet, _super);
    function NSSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._objects = [];
        return _this;
    }
    NSSet.set = function () {
        var s = new NSSet();
        s.init();
        return s;
    };
    NSSet.prototype.addObject = function (object) {
        if (this._objects.containsObject(object) == true)
            return;
        this._objects.addObject(object);
    };
    NSSet.prototype.removeObject = function (object) {
        if (this._objects.containsObject(object) == false)
            return;
        this._objects.removeObject(object);
    };
    NSSet.prototype.removeAllObjects = function () {
        this._objects = [];
    };
    NSSet.prototype.indexOfObject = function (object) {
        return this._objects.indexOf(object);
    };
    NSSet.prototype.containsObject = function (object) {
        return this._objects.indexOfObject(object) > -1 ? true : false;
    };
    NSSet.prototype.objectAtIndex = function (index) {
        return this._objects[index];
    };
    Object.defineProperty(NSSet.prototype, "allObjects", {
        get: function () {
            return this._objects;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NSSet.prototype, "count", {
        get: function () {
            return this._objects.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NSSet.prototype, "length", {
        get: function () {
            return this._objects.length;
        },
        enumerable: false,
        configurable: true
    });
    NSSet.prototype.copy = function () {
        var set = new NSSet();
        set.init();
        for (var index = 0; index < this._objects.length; index++) {
            var obj = this._objects[index];
            set.addObject(obj);
        }
        return set;
    };
    NSSet.prototype.filterWithPredicate = function (predicate) {
        var objs = (0,_NSPredicate__WEBPACK_IMPORTED_MODULE_1__._NSPredicateFilterObjects)(this._objects, predicate);
        return objs;
    };
    // Prevent KVO on special properties
    NSSet.prototype.addObserver = function (obs, keypath, context) {
        if (keypath == "count" || keypath == "length")
            throw new Error("NSSet: Can't observe count. It's not KVO Compilant");
        _super.prototype.addObserver.call(this, obs, keypath, context);
    };
    return NSSet;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/NSSortDescriptor.ts":
/*!*************************************!*\
  !*** ./sources/NSSortDescriptor.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSSortDescriptor: () => (/* binding */ NSSortDescriptor),
/* harmony export */   _NSSortDescriptorSortObjects: () => (/* binding */ _NSSortDescriptorSortObjects)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/**
 * Created by godshadow on 28/09/2016.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NSSortDescriptor = /** @class */ (function (_super) {
    __extends(NSSortDescriptor, _super);
    function NSSortDescriptor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.key = null;
        _this.ascending = false;
        return _this;
    }
    NSSortDescriptor.sortDescriptorWithKey = function (key, ascending) {
        var sd = new NSSortDescriptor();
        sd.initWithKey(key, ascending);
        return sd;
    };
    NSSortDescriptor.prototype.initWithKey = function (key, ascending) {
        this.key = key;
        this.ascending = ascending;
    };
    return NSSortDescriptor;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));

//
// For internal purposes: Don't use it, could change
//
function _NSSortDescriptorSortObjects(objs, sortDescriptors) {
    var resultObjects = null;
    if (objs.length == 0 || sortDescriptors == null) {
        resultObjects = objs.slice(0);
    }
    else {
        if (sortDescriptors == null)
            return objs;
        if (objs.length == 0)
            return objs;
        resultObjects = objs.sort(function (a, b) {
            return _NSSortDescriptorSortObjects2(a, b, sortDescriptors, 0);
            //return instance._NSSortDescriptorSortObjects2(a, b, sortDescriptors, 0);
        });
    }
    return resultObjects;
}
function _NSSortDescriptorSortObjects2(a, b, sortDescriptors, index) {
    if (index >= sortDescriptors.length)
        return 0;
    var sd = sortDescriptors[index];
    var key = sd.key;
    var lv = a[key];
    var rv = b[key];
    if (typeof lv === "string") {
        lv = lv.toLocaleLowerCase();
    }
    if (typeof rv === "string") {
        rv = rv.toLocaleLowerCase();
    }
    if (typeof lv === "string" && typeof rv === "string" && lv.length != rv.length) {
        // Check the length
        var lv2 = lv;
        var rv2 = rv;
        var sortValue = 0;
        if (lv.length > rv.length) {
            lv2 = lv.substr(0, rv.length);
            sortValue = sd.ascending ? 1 : -1;
        }
        else if (lv.length < rv.length) {
            rv2 = rv.substr(0, lv.length);
            sortValue = sd.ascending ? -1 : 1;
        }
        if (lv2 == rv2)
            return sortValue;
        else if (lv2 < rv2)
            return sd.ascending ? -1 : 1;
        else
            return sd.ascending ? 1 : -1;
    }
    else if (lv == rv)
        return _NSSortDescriptorSortObjects2(a, b, sortDescriptors, ++index);
    else if (lv < rv)
        return sd.ascending ? -1 : 1;
    else
        return sd.ascending ? 1 : -1;
}


/***/ }),

/***/ "./sources/NSString.ts":
/*!*****************************!*\
  !*** ./sources/NSString.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NSLocalizeString: () => (/* binding */ NSLocalizeString)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);

String.prototype.lastPathComponent = function () {
    return (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreStringLastPathComponent)(this);
};
String.prototype.pathExtension = function () {
    return (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreStringPathExtension)(this);
};
String.prototype.stringByAppendingPathComponent = function (path) {
    return (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreStringAppendPathComponent)(this, path);
};
String.prototype.stringByDeletingLastPathComponent = function () {
    return (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreStringDeletingLastPathComponent)(this);
};
String.prototype.hasPreffix = function (preffix) {
    return (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreStringHasPreffix)(this, preffix);
};
String.prototype.hasSuffix = function (suffix) {
    return (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreStringHasSuffix)(this, suffix);
};
function NSLocalizeString(key, comments) {
    return (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOLocalizeString)(key, comments);
}


/***/ }),

/***/ "./sources/NotificationCenter.ts":
/*!***************************************!*\
  !*** ./sources/NotificationCenter.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Notification: () => (/* binding */ Notification),
/* harmony export */   NotificationCenter: () => (/* binding */ NotificationCenter)
/* harmony export */ });
/**
 * Created by godshadow on 11/3/16.
 */
var Notification = /** @class */ (function () {
    function Notification(name, object, userInfo) {
        this.name = name;
        this.object = object;
        this.userInfo = userInfo;
    }
    return Notification;
}());

var NotificationCenter = /** @class */ (function () {
    function NotificationCenter() {
        this.notificationNames = {};
        if (NotificationCenter._sharedInstance) {
            throw new Error("Error: Instantiation failed: Use defaultCenter() instead of new.");
        }
        NotificationCenter._sharedInstance = this;
    }
    NotificationCenter.defaultCenter = function () {
        return NotificationCenter._sharedInstance;
    };
    NotificationCenter.prototype.addObserver = function (obs, name, fn) {
        var notes = this.notificationNames[name];
        if (notes == null) {
            notes = [];
        }
        var item = { "observer": obs, "function": fn };
        notes.push(item);
        this.notificationNames[name] = notes;
    };
    ;
    NotificationCenter.prototype.removeObserver = function (obs, name) {
        var notes = this.notificationNames[name];
        if (notes == null)
            return;
        var index = -1;
        for (var count = 0; count < notes.length; count++) {
            var item = notes[count];
            var obsAux = item["observer"];
            if (obsAux === obs) {
                index = count;
                break;
            }
        }
        if (index > -1) {
            notes.splice(index, 1);
        }
    };
    NotificationCenter.prototype.postNotification = function (name, object, userInfo) {
        var notes = this.notificationNames[name];
        if (notes == null)
            return;
        var n = new Notification(name, object, userInfo);
        for (var count = 0; count < notes.length; count++) {
            var item = notes[count];
            var obs = item["observer"];
            var fn = item["function"];
            fn.call(obs, n);
        }
    };
    NotificationCenter._sharedInstance = new NotificationCenter();
    return NotificationCenter;
}());



/***/ }),

/***/ "./sources/NumberFormatter.ts":
/*!************************************!*\
  !*** ./sources/NumberFormatter.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NumberFormatter: () => (/* binding */ NumberFormatter)
/* harmony export */ });
/* harmony import */ var _Formatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Formatter */ "./sources/Formatter.ts");
/* harmony import */ var _Locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Locale */ "./sources/Locale.ts");
/* harmony import */ var _NSNumber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./NSNumber */ "./sources/NSNumber.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var _NSNumberFormatterType;
(function (_NSNumberFormatterType) {
    _NSNumberFormatterType[_NSNumberFormatterType["Int"] = 0] = "Int";
    _NSNumberFormatterType[_NSNumberFormatterType["Decimal"] = 1] = "Decimal";
})(_NSNumberFormatterType || (_NSNumberFormatterType = {}));
var NumberFormatter = /** @class */ (function (_super) {
    __extends(NumberFormatter, _super);
    function NumberFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.numberStyle = NumberFormatter.Style.none;
        _this.locale = null;
        _this.minimumFractionDigits = 0;
        _this.maximumFractionDigits = 0;
        _this.groupingSeparator = null;
        _this.currencySymbol = null;
        _this.currencyCode = null;
        _this.currencyHasSpaces = true;
        _this.currencyIsRight = true;
        return _this;
    }
    NumberFormatter.prototype.init = function () {
        _super.prototype.init.call(this);
        this.locale = _Locale__WEBPACK_IMPORTED_MODULE_1__.Locale.currentLocale();
        this.groupingSeparator = this.locale.groupingSeparator;
        this.currencySymbol = this.locale.currencySymbol;
        this.currencyCode = this.locale.currencyCode;
        switch (this.locale.region) {
            case "US":
            case "CA":
                this.currencyHasSpaces = false;
                this.currencyIsRight = false;
                break;
        }
    };
    NumberFormatter.prototype.numberFromString = function (str) {
        var _a;
        if (str === null)
            return null;
        var result, parseString, numberString, type;
        _a = this._parse(str), result = _a[0], parseString = _a[1], numberString = _a[2], type = _a[3];
        if (result == true) {
            var value = null;
            if (type == _NSNumberFormatterType.Int) {
                value = parseInt(numberString);
            }
            else if (type == _NSNumberFormatterType.Decimal) {
                value = parseFloat(numberString);
            }
            return isNaN(value) ? null : value;
        }
        return null;
    };
    NumberFormatter.prototype.stringFromNumber = function (number) {
        // return _injectIntoOptional(this.stringForObjectValue(number));//TODO automatically refactor function results
        if (number instanceof _NSNumber__WEBPACK_IMPORTED_MODULE_2__.NSNumber)
            return this.stringForObjectValue(number);
        return this.stringForObjectValue(_NSNumber__WEBPACK_IMPORTED_MODULE_2__.NSNumber.numberWithFloat(number)); //TODO automatically refactor function results
    };
    NumberFormatter.prototype.stringForObjectValue = function (value) {
        var _a;
        var number = value != null && value instanceof _NSNumber__WEBPACK_IMPORTED_MODULE_2__.NSNumber ? value : _NSNumber__WEBPACK_IMPORTED_MODULE_2__.NSNumber.numberWithFloat(0);
        var str = number.floatValue.toString();
        var intValue = null;
        var floatValue = null;
        var array = str.split(".");
        if (array.length == 1) {
            // Only int
            intValue = array[0];
        }
        else if (array.length == 2) {
            intValue = array[0];
            floatValue = array[1];
        }
        // Check the round rules
        if (floatValue != null) {
            _a = this.round(intValue, floatValue), intValue = _a[0], floatValue = _a[1];
        }
        var res = "";
        var minusOffset = intValue.charAt(0) == "-" ? 1 : 0;
        if (intValue.length > (3 + minusOffset)) {
            var offset = Math.floor((intValue.length - minusOffset) / 3);
            if (((intValue.length - minusOffset) % 3) == 0)
                offset--;
            var posArray = [];
            var intLen = intValue.length;
            for (var index = offset; index > 0; index--) {
                posArray.push(intLen - (index * 3));
            }
            var posArrayIndex = 0;
            var groupPos = posArray[0];
            for (var index = 0; index < intLen; index++) {
                if (index == groupPos) {
                    res += this.groupingSeparator;
                    posArrayIndex++;
                    groupPos = posArrayIndex < posArray.length ? posArray[posArrayIndex] : -1;
                }
                var ch = intValue[index];
                res += ch;
            }
        }
        else {
            res = intValue;
        }
        if (this.minimumFractionDigits > 0 && floatValue == null)
            floatValue = "";
        if (floatValue != null) {
            res += this.locale.decimalSeparator;
            if (this.minimumFractionDigits > 0 && floatValue.length < this.minimumFractionDigits) {
                for (var index = 0; index < this.minimumFractionDigits; index++) {
                    if (index < floatValue.length)
                        res += floatValue[index];
                    else
                        res += "0";
                }
            }
            else {
                res += floatValue;
            }
        }
        if (this.numberStyle.rawValue == NumberFormatter.Style.percent.rawValue)
            res += "%";
        res = this.stringByAppendingCurrencyString(res);
        return res;
    };
    NumberFormatter.prototype.round = function (intValue, floatValue) {
        if (floatValue.length <= this.maximumFractionDigits)
            return [intValue, floatValue];
        // Check float first        
        var roundedFloat = "";
        var d = parseInt(floatValue.substr(this.maximumFractionDigits, 1));
        var inc = d < 5 ? 0 : 1;
        for (var index = this.maximumFractionDigits - 1; index >= 0; index--) {
            if (inc == 0) {
                roundedFloat = floatValue.substring(0, index + 1) + roundedFloat;
                break;
            }
            var digit = parseInt(floatValue.substr(index, 1));
            if (digit == 9) {
                inc = 1;
                roundedFloat = "0" + roundedFloat;
            }
            else {
                inc = 0;
                var newDigit = digit + 1;
                roundedFloat = newDigit + roundedFloat;
            }
        }
        // Removes Zeros
        var removeIndex = null;
        for (var index = roundedFloat.length - 1; index >= this.minimumFractionDigits; index--) {
            var digit = roundedFloat.substr(index, 1);
            if (digit != "0")
                break;
            removeIndex = index;
        }
        if (removeIndex != null)
            roundedFloat = roundedFloat.substring(0, removeIndex);
        if (inc == 0)
            return [intValue, roundedFloat];
        var roundedInt = "";
        for (var index = intValue.length - 1; index >= 0; index--) {
            var digit = parseInt(intValue.substr(index, 1));
            var newDigit = digit + inc;
            if (newDigit == 10) {
                inc = 1;
                roundedInt = "0" + roundedInt;
            }
            else {
                inc = 0;
                roundedInt = intValue.substring(0, index) + newDigit.toString() + roundedInt;
                break;
            }
        }
        return [roundedInt, roundedFloat];
    };
    NumberFormatter.prototype.stringByAppendingCurrencyString = function (text) {
        var currency = "";
        if (this.numberStyle.rawValue == NumberFormatter.Style.currency.rawValue) {
            currency = this.currencySymbol;
            if (currency.length == 0)
                currency = this.currencyCode; // If there's no symbol, add the code instead.
        }
        else if (this.numberStyle.rawValue == NumberFormatter.Style.currencyISOCode.rawValue)
            currency = this.currencyCode;
        else {
            return text;
        }
        if (currency.length == 0)
            return text;
        var result = "";
        if (this.currencyIsRight == true) {
            result = text + (this.currencyHasSpaces ? " " : "") + currency;
        }
        else {
            result = currency + (this.currencyHasSpaces ? " " : "") + text;
        }
        return result;
    };
    NumberFormatter.prototype.isPartialStringValid = function (str) {
        var _a;
        if (str.length == 0)
            return [true, str];
        var result, newStr;
        _a = this._parse(str), result = _a[0], newStr = _a[1];
        return [result, newStr];
    };
    NumberFormatter.prototype._parse = function (str) {
        var number = 0;
        var parseString = "";
        var numberString = "";
        var type = _NSNumberFormatterType.Int;
        var minusSymbol = false;
        var percentSymbol = false;
        for (var index = 0; index < str.length; index++) {
            var ch = str[index];
            if (ch == this.locale.decimalSeparator && type != _NSNumberFormatterType.Decimal) {
                parseString += ch;
                numberString += ".";
                type = _NSNumberFormatterType.Decimal;
            }
            else if (ch == "-" && minusSymbol == false) {
                parseString += ch;
                numberString += ch;
                minusSymbol = true;
            }
            else if (ch == "%"
                && this.numberStyle.rawValue == NumberFormatter.Style.percent.rawValue
                && percentSymbol == false) {
                percentSymbol = true;
                parseString += ch;
            }
            else if (ch == " ") {
                continue;
            }
            else if (!isNaN(parseInt(ch))) {
                parseString += ch;
                numberString += ch;
            }
            else
                return [(parseString.length > 0 ? true : false), parseString, numberString, type];
        }
        return [true, parseString, numberString, type];
    };
    NumberFormatter.Style = /** @class */ (function () {
        function class_1() {
        }
        Object.defineProperty(class_1, "none", {
            get: function () { return Object.assign(new NumberFormatter.Style(), { rawValue: 0 }); },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1, "decimal", {
            get: function () { return Object.assign(new NumberFormatter.Style(), { rawValue: 1 }); },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1, "currency", {
            get: function () { return Object.assign(new NumberFormatter.Style(), { rawValue: 2 }); },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1, "currencyISOCode", {
            get: function () { return Object.assign(new NumberFormatter.Style(), { rawValue: 3 }); },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1, "percent", {
            get: function () { return Object.assign(new NumberFormatter.Style(), { rawValue: 4 }); },
            enumerable: false,
            configurable: true
        });
        return class_1;
    }());
    return NumberFormatter;
}(_Formatter__WEBPACK_IMPORTED_MODULE_0__.Formatter));



/***/ }),

/***/ "./sources/Operation.ts":
/*!******************************!*\
  !*** ./sources/Operation.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Operation: () => (/* binding */ Operation)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Operation = /** @class */ (function (_super) {
    __extends(Operation, _super);
    function Operation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = null;
        _this.target = null;
        _this.completion = null;
        _this._dependencies = [];
        _this._isExecuting = false;
        _this._isFinished = false;
        _this._ready = true;
        return _this;
    }
    Object.defineProperty(Operation.prototype, "dependencies", {
        get: function () { return this._dependencies; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Operation.prototype, "isExecuting", {
        get: function () { return this.executing(); },
        enumerable: false,
        configurable: true
    });
    Operation.prototype.setExecuting = function (value) {
        if (value == this._isExecuting)
            return;
        this.willChangeValue("isExecuting");
        this._isExecuting = value;
        this.didChangeValue("isExecuting");
    };
    Object.defineProperty(Operation.prototype, "isFinished", {
        get: function () { return this.finished(); },
        enumerable: false,
        configurable: true
    });
    Operation.prototype.setFinished = function (value) {
        if (value == this._isFinished)
            return;
        this.willChangeValue("isFinished");
        this._isFinished = value;
        this.didChangeValue("isFinished");
    };
    Operation.prototype.setReady = function (value) {
        if (value == this._ready)
            return;
        this.willChangeValue("ready");
        this._ready = value;
        this.didChangeValue("ready");
    };
    Object.defineProperty(Operation.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: false,
        configurable: true
    });
    Operation.prototype.addDependency = function (operation) {
        this._dependencies.push(operation);
        if (operation.isFinished == false) {
            operation.addObserver(this, "isFinished");
            this.setReady(false);
        }
    };
    // Non concurrent task
    Operation.prototype.main = function () { };
    // Concurrent task
    Operation.prototype.start = function () {
        this.setExecuting(true);
        this.main();
        this.setExecuting(false);
        this.setFinished(true);
    };
    Operation.prototype.executing = function () {
        return this._isExecuting;
    };
    Operation.prototype.finished = function () {
        return this._isFinished;
    };
    Operation.prototype.observeValueForKeyPath = function (keyPath, type, object, ctx) {
        if (type != "did")
            return;
        if (keyPath == "isFinished") {
            var op = object;
            if (op.isFinished == true) {
                object.removeObserver(this, "isFinished");
                this.checkDependecies();
            }
        }
    };
    Operation.prototype.checkDependecies = function () {
        for (var index = 0; index < this._dependencies.length; index++) {
            var op = this._dependencies[index];
            if (op.isFinished == false)
                return;
        }
        // So if we are in this point, means every dependecy is finished
        // and we can start our own task
        this.setReady(true);
    };
    return Operation;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));

var NSBlockOperation = /** @class */ (function (_super) {
    __extends(NSBlockOperation, _super);
    function NSBlockOperation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.executionBlocks = [];
        return _this;
    }
    NSBlockOperation.operationWithBlock = function (target, block) {
        var op = new NSBlockOperation();
        op.init();
    };
    NSBlockOperation.prototype.addExecutionBlock = function (target, block) {
        var item = {};
        item["Target"] = target;
        item["Block"] = block;
        this.executionBlocks.push(item);
    };
    NSBlockOperation.prototype.main = function () {
        for (var index = 0; index < this.executionBlocks.length; index++) {
            var item = this.executionBlocks[index];
            var target = item["Target"];
            var block = item["Block"];
            block.call(target);
        }
    };
    return NSBlockOperation;
}(Operation));


/***/ }),

/***/ "./sources/OperationQueue.ts":
/*!***********************************!*\
  !*** ./sources/OperationQueue.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OperationQueue: () => (/* binding */ OperationQueue)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var OperationQueue = /** @class */ (function (_super) {
    __extends(OperationQueue, _super);
    function OperationQueue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._operations = [];
        _this._suspended = false;
        return _this;
    }
    OperationQueue.prototype.addOperation = function (operation) {
        if (operation.isFinished == true) {
            throw new Error("NSOperationQueue: Tying to add an operation already finished");
        }
        this.willChangeValue("operationCount");
        this.willChangeValue("operations");
        this._operations.addObject(operation);
        this.didChangeValue("operationCount");
        this.didChangeValue("operations");
        if (operation.ready == false) {
            operation.addObserver(this, "ready", null);
        }
        else {
            operation.addObserver(this, "isFinished", null);
            if (this.suspended == false)
                operation.start();
        }
    };
    OperationQueue.prototype.removeOperation = function (operation) {
        var index = this._operations.indexOf(operation);
        if (index == -1)
            return;
        this.willChangeValue("operationCount");
        this.willChangeValue("operations");
        this._operations.splice(index, 1);
        this.didChangeValue("operationCount");
        this.didChangeValue("operations");
    };
    Object.defineProperty(OperationQueue.prototype, "operations", {
        get: function () {
            return this._operations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperationQueue.prototype, "operationCount", {
        get: function () {
            return this._operations.count;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperationQueue.prototype, "suspended", {
        get: function () {
            return this._suspended;
        },
        set: function (value) {
            this.setSupended(value);
        },
        enumerable: false,
        configurable: true
    });
    OperationQueue.prototype.setSupended = function (value) {
        if (this._suspended == value)
            return;
        this._suspended = value;
        // if the value is false, we don't need to do anything
        if (value == true)
            return;
        // This means we need to re-active every operation
        for (var index = 0; index < this.operations.length; index++) {
            var op = this.operations[index];
            if (op.ready == true)
                op.start();
        }
    };
    OperationQueue.prototype.observeValueForKeyPath = function (keyPath, type, object, ctx) {
        if (type != "did")
            return;
        if (keyPath == "ready") {
            var op = object;
            if (op.ready == true) {
                op.removeObserver(this, "ready");
                op.addObserver(this, "isFinished", null);
                if (this.suspended == false)
                    op.start();
            }
        }
        else if (keyPath == "isFinished") {
            var op = object;
            if (op.isFinished == true) {
                op.removeObserver(this, "isFinished");
                this.removeOperation(op);
                if (op.target != null && op.completion != null)
                    op.completion.call(op.target);
            }
        }
    };
    return OperationQueue;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/PropertyListSerialization.ts":
/*!**********************************************!*\
  !*** ./sources/PropertyListSerialization.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyListFormat: () => (/* binding */ PropertyListFormat),
/* harmony export */   PropertyListReadOptions: () => (/* binding */ PropertyListReadOptions),
/* harmony export */   PropertyListSerialization: () => (/* binding */ PropertyListSerialization),
/* harmony export */   PropertyListWriteOptions: () => (/* binding */ PropertyListWriteOptions)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/* harmony import */ var _XMLParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./XMLParser */ "./sources/XMLParser.ts");
// import { NSObject } from "./NSObject";
// import { NSError } from "./NSError";
// import { XMLParser } from "./NSXMLParser";
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var PropertyListFormat;
(function (PropertyListFormat) {
    PropertyListFormat[PropertyListFormat["OpenStepFormat"] = 0] = "OpenStepFormat";
    PropertyListFormat[PropertyListFormat["XMLFormat_v1_0"] = 1] = "XMLFormat_v1_0";
    PropertyListFormat[PropertyListFormat["BinaryFormat_v1_0"] = 2] = "BinaryFormat_v1_0";
})(PropertyListFormat || (PropertyListFormat = {}));
var PropertyListReadOptions;
(function (PropertyListReadOptions) {
    PropertyListReadOptions[PropertyListReadOptions["None"] = 0] = "None";
})(PropertyListReadOptions || (PropertyListReadOptions = {}));
var PropertyListWriteOptions;
(function (PropertyListWriteOptions) {
    PropertyListWriteOptions[PropertyListWriteOptions["None"] = 0] = "None";
})(PropertyListWriteOptions || (PropertyListWriteOptions = {}));
var PropertyListSerialization = /** @class */ (function (_super) {
    __extends(PropertyListSerialization, _super);
    function PropertyListSerialization() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = null;
        _this.plist = null;
        _this.rootItem = null;
        // #region XML Parser delegate 
        _this.currentElement = null;
        _this.currentElementType = null;
        _this.currentValue = null;
        _this.currentKey = null;
        _this.currentString = null;
        _this.itemStack = [];
        _this.contentString = null;
        return _this;
    }
    PropertyListSerialization.propertyListWithData = function (data, options, format, error) {
        var pl = new PropertyListSerialization();
        pl.initWithData(data, options, format);
        var item = pl.parseData(error);
        return item;
    };
    PropertyListSerialization.dataWithpropertyList = function (plist, format, options, error) {
        var pl = new PropertyListSerialization();
        pl.initWithObject(plist, options, format);
        var data = pl.parsePList(error);
        return data;
    };
    PropertyListSerialization.prototype.initWithData = function (data, options, format) {
        _super.prototype.init.call(this);
        this.data = data;
    };
    PropertyListSerialization.prototype.initWithObject = function (plist, options, format) {
        _super.prototype.init.call(this);
        this.plist = plist;
    };
    PropertyListSerialization.prototype.parseData = function (error) {
        this.currentElement = null;
        var parser = new _XMLParser__WEBPACK_IMPORTED_MODULE_1__.XMLParser();
        parser.initWithString(this.data, this);
        parser.parse();
        return this.rootItem;
    };
    PropertyListSerialization.prototype.parserDidStartElement = function (parser, element, attributes) {
        if (element == "dict") {
            var item = {};
            if (this.currentElement != null && this.currentElementType == 0) {
                var key = this.currentKey;
                this.currentElement[key] = item;
            }
            else if (this.currentElement != null && this.currentElementType == 1) {
                this.currentElement.push(item);
            }
            this.currentElement = item;
            this.currentElementType = 0;
            this.itemStack.push({ "Element": item, "Type": 0 });
            if (this.rootItem == null)
                this.rootItem = item;
        }
        else if (element == "array") {
            var item = [];
            if (this.currentElement != null && this.currentElementType == 0) {
                var key = this.currentKey;
                this.currentElement[key] = item;
            }
            else if (this.currentElement != null && this.currentElementType == 1) {
                this.currentElement.push(item);
            }
            this.currentElement = item;
            this.currentElementType = 1;
            this.itemStack.push({ "Element": item, "Type": 1 });
            if (this.rootItem == null)
                this.rootItem = item;
        }
        this.currentString = "";
    };
    PropertyListSerialization.prototype.parserFoundCharacters = function (parser, characters) {
        this.currentString += characters;
    };
    PropertyListSerialization.prototype.parserDidEndElement = function (parser, element) {
        if (element == "key") {
            this.currentKey = this.currentString;
        }
        else if (element == "string" || element == "integer" || element == "real" || element == "data") {
            this.currentValue = this.currentString;
            if (element == "integer")
                this.currentValue = parseInt(this.currentString);
            if (element == "real")
                this.currentValue = parseFloat(this.currentString);
            if (this.currentElementType == 1)
                this.currentElement.push(this.currentValue);
            else if (this.currentElementType == 0 && this.currentKey != null) {
                var key = this.currentKey;
                var value = this.currentValue;
                this.currentElement[key] = value;
            }
        }
        else if (element == "dict" || element == "array") {
            if (this.itemStack.length > 1) {
                var lastItem = this.itemStack[this.itemStack.length - 2];
                this.currentElement = lastItem["Element"];
                this.currentElementType = lastItem["Type"];
            }
            else {
                this.currentElement = null;
                this.currentElementType = null;
            }
            this.itemStack.splice(-1, 1);
        }
    };
    PropertyListSerialization.prototype.parserDidEndDocument = function (parser) {
    };
    PropertyListSerialization.prototype.parsePList = function (error) {
        this.contentString = '<?xml version="1.0" encoding="UTF-8"?>';
        this.contentString += '<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">';
        this.contentString += '<plist version="1.0">';
        this.parseObject(this.plist);
        this.contentString += '</plist>';
        return this.contentString;
    };
    PropertyListSerialization.prototype.parseObject = function (object) {
        if (typeof object === "string")
            this.parseString(object);
        else if (typeof object === "number")
            this.parseNumber(object);
        //else if (typeof object === "Date") this.parseDate(object);
        else if (object instanceof Array)
            this.parseArray(object);
        else
            this.parseDictionary(object);
    };
    PropertyListSerialization.prototype.parseString = function (object) {
        this.contentString += "<string>";
        this.contentString += object;
        this.contentString += "</string>";
    };
    PropertyListSerialization.prototype.parseNumber = function (object) {
        if (object % 1 === 0) {
            this.contentString += "<integer>";
            this.contentString += object;
            this.contentString += "</integer>";
        }
        else {
            this.contentString += "<real>";
            this.contentString += object;
            this.contentString += "</real>";
        }
    };
    PropertyListSerialization.prototype.parseArray = function (objects) {
        this.contentString += "<array>";
        for (var index = 0; index < objects.length; index++) {
            var obj = objects[index];
            this.parseObject(obj);
        }
        this.contentString += "</array>";
    };
    PropertyListSerialization.prototype.parseDictionary = function (objects) {
        this.contentString += "<dict>";
        for (var key in objects) {
            this.contentString += "<key>";
            this.contentString += key;
            this.contentString += "</key>";
            var obj = objects[key];
            this.parseObject(obj);
        }
        this.contentString += "</dict>";
    };
    return PropertyListSerialization;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/Timer.ts":
/*!**************************!*\
  !*** ./sources/Timer.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Timer: () => (/* binding */ Timer)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/**
 * Created by godshadow on 21/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._timerInterval = 0;
        _this._repeat = false;
        _this._target = null;
        _this._completion = null;
        _this._coreTimer = null;
        return _this;
    }
    //TODO: Remove this hack (method name) for swift js
    Timer.scheduledTimerWithTimeIntervalRepeatsBlock = function (timeInterval, repeat, completion) {
        var timer = new Timer();
        timer.initWithTimeInterval(timeInterval, repeat, completion);
        timer.fire();
        return timer;
    };
    Timer.scheduledTimerWithTimeInterval = function (timeInterval, repeat, completion) {
    };
    Timer.prototype.initWithTimeInterval = function (timeInterval, repeat, completion) {
        this._timerInterval = timeInterval;
        this._repeat = repeat;
        //this._target = target;
        this._completion = completion;
    };
    Timer.prototype.fire = function () {
        var instance = this;
        if (this._repeat) {
            this._coreTimer = setInterval(function () {
                instance._timerCallback.call(instance);
            }, this._timerInterval);
        }
        else {
            this._coreTimer = setTimeout(function () {
                instance._timerCallback.call(instance);
            }, this._timerInterval);
        }
    };
    Timer.prototype.invalidate = function () {
        if (this._repeat)
            clearInterval(this._coreTimer);
        else
            clearTimeout(this._coreTimer);
    };
    Timer.prototype._timerCallback = function () {
        if (this._completion != null)
            this._completion(this);
        if (this._repeat == true)
            this.invalidate();
    };
    return Timer;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/URL.ts":
/*!************************!*\
  !*** ./sources/URL.ts ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
Object.defineProperty(Array.prototype, "absoluteString", {
    get: function () {
        var str = "";
        if (this.scheme.length > 0)
            str += this.scheme + "://";
        if (this.host.length > 0)
            str += this.host;
        if (this.port.length > 0)
            str += ":" + this.port;
        if (this.path.length > 0)
            str += "/" + this.path;
        return str;
    },
    enumerable: true,
    configurable: true
});

// enum URLTokenType
// {
//     Protocol,
//     Host,
//     Path,
//     Param,
//     Value
// }
// export class URL extends NSObject 
// {    
//     baseURL:URL = null;
//     absoluteString:string = null;
//     scheme:string = null;
//     user:string = null;
//     password = null;
//     host:string = null;
//     port:number = 0;
//     hostname:string = null;
//     path:string = "/";
//     file:string = null;
//     pathExtension:string = null;
//     params = [];
//     public static urlWithString(urlString:string) : URL
//     {
//         let url = new URL();
//         url.initWithURLString(urlString);
//         return url;
//     }
//     initWithScheme(scheme:string, host:string, path:string){
//         super.init();
//         this.scheme = scheme;
//         this.host = host;
//         this.path = path;
//         this.absoluteString = "";
//         if (scheme.length > 0) this.absoluteString += scheme + "://";
//         if (host.length > 0) this.absoluteString += host + "/";
//         if (path.length > 0) this.absoluteString += path;                
//     }
//     initWithURLString(urlString:string)
//     {
//         super.init();
//         this.absoluteString = urlString;
//         this._parseURLString(urlString);
//     }
//     private _parseURLString(urlString:string)
//     {    
//         let param = "";
//         let value = "";
//         let token = "";
//         let step = URLTokenType.Protocol;
//         let foundPort = false;
//         let foundExt = false;        
//         for (let index = 0; index < urlString.length; index++)
//         {
//             let ch = urlString.charAt(index);
//             if (ch == ":")
//             {
//                 if (step == URLTokenType.Protocol)
//                 {
//                     this.scheme = token;
//                     token = "";
//                     index += 2; //Igonring the double slash // from the protocol (http://)
//                     step = URLTokenType.Host;
//                 }
//                 else if (step == URLTokenType.Host)
//                 {
//                     this.hostname = token;
//                     token = "";
//                     foundPort = true;
//                 }
//             }
//             else if (ch == "/")
//             {
//                 if (step == URLTokenType.Host)
//                 {
//                     if (foundPort == true)
//                     {
//                         this.host = this.hostname + ":" + token;
//                         this.port = parseInt(token);                        
//                     }
//                     else 
//                     {
//                         this.host = token;
//                         this.hostname = token;
//                     }
//                     step = URLTokenType.Path;                    
//                 }
//                 else
//                 { 
//                     this.path += token + ch;                    
//                 }
//                 token = "";                    
//             }
//             else if (ch == "." && step == URLTokenType.Path)
//             {
//                 this.file = token;
//                 foundExt = true;
//                 token = "";
//             }
//             else if (ch == "?")
//             {
//                 if (foundExt == true)
//                 {
//                     this.file += "." + token;
//                     this.pathExtension = token;
//                 }
//                 else 
//                     this.file = token;
//                 token = "";
//                 step = URLTokenType.Param;
//             }
//             else if (ch == "&")
//             {
//                 let item = {"Key" : param, "Value":value};
//                 this.params.push(item);
//                 step = URLTokenType.Param;
//                 param = "";
//                 value = "";
//             }
//             else if (ch == "=")
//             {
//                 param = token;
//                 step = URLTokenType.Value;
//                 token = "";
//             }
//             else
//             {
//                 token += ch;
//             }
//         }
//         if (token.length > 0)
//         {
//             if (step == URLTokenType.Path)
//             {
//                 if (foundExt == true)
//                 {
//                     this.file += "." + token;
//                     this.pathExtension = token;
//                 }
//                 else
//                     this.path += token;
//             }
//             else if (step == URLTokenType.Param)
//             {
//                 let i = {"key" : token};
//                 this.params.push(i);
//             }
//             else if (step == URLTokenType.Value)
//             {
//                 let item = {"Key" : param, "Value" : token};
//                 this.params.push(item);                
//             }
//         }
//     }    
//     public urlByAppendingPathComponent(path:string) : URL
//     {                
//         let urlString = this.scheme + "://" + this.host + this.path;
//         if (urlString.charAt(urlString.length - 1) != "/")
//             urlString += "/";
//         if (path.charAt(0) != "/")
//             urlString += path;
//         else
//             urlString += path.substr(1);
//         let newURL = URL.urlWithString(urlString);
//         return newURL;
//     }
//     public standardizedURL() : URL
//     {
//         return null;
//     }
// }


/***/ }),

/***/ "./sources/URLConnection.ts":
/*!**********************************!*\
  !*** ./sources/URLConnection.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   URLConnection: () => (/* binding */ URLConnection)
/* harmony export */ });
/**
 * Created by godshadow on 14/3/16.
 */
var URLConnection = /** @class */ (function () {
    function URLConnection() {
        this.delegate = null;
        this.blockFN = null;
        this.blockTarget = null;
        this.xmlHttpRequest = null;
    }
    URLConnection.prototype.initWithRequest = function (request, delegate) {
        this.request = request;
        this.delegate = delegate;
        this.start();
    };
    URLConnection.prototype.initWithRequestBlock = function (request, blockTarget, blockFN) {
        this.request = request;
        this.blockFN = blockFN;
        this.blockTarget = blockTarget;
        this.start();
    };
    URLConnection.prototype.start = function () {
        _http_request(this, this.request.url.href, this.request.headers, this.request.httpMethod, this.request.httpBody, this.request.binary, this.delegate, this.blockTarget, this.blockFN, this.request.download);
    };
    return URLConnection;
}());

function _http_request(instance, urlString, headers, method, body, binary, delegate, target, completion, download) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        var body = this.responseText;
        if (this.status < 300 && body != null) {
            // Success!
            if (delegate != null) {
                delegate.connectionDidReceiveText(instance, body);
            }
            else if (target != null) {
                completion.call(target, this.status, body);
            }
        }
        else {
            // something went wrong
            if (delegate != null) {
                delegate.connectionDidFail(instance);
            }
            else if (target != null) {
                completion.call(target, this.status, body);
            }
        }
    };
    xhr.open(method, urlString);
    // Add headers
    for (var count = 0; count < headers.length; count++) {
        var item = headers[count];
        xhr.setRequestHeader(item["Field"], item["Value"]);
    }
    if (binary == true) {
        xhr.responseType = "arraybuffer";
    }
    if (method == "GET" || body == null) {
        xhr.send();
    }
    else {
        xhr.send(body);
    }
}
function _http_request_sync(urlString, headers, method, body, binary) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, urlString, false);
    // Add headers
    for (var count = 0; count < headers.length; count++) {
        var item = headers[count];
        xhr.setRequestHeader(item["Field"], item["Value"]);
    }
    if (binary == true) {
        xhr.responseType = "arraybuffer";
    }
    if (method == "GET" || body == null) {
        xhr.send();
    }
    else {
        xhr.send(body);
    }
    return xhr.responseText;
}


/***/ }),

/***/ "./sources/URLRequest.ts":
/*!*******************************!*\
  !*** ./sources/URLRequest.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   URLRequest: () => (/* binding */ URLRequest)
/* harmony export */ });
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

// import { URL } from "./URL";
var URLRequest = /** @class */ (function (_super) {
    __extends(URLRequest, _super);
    function URLRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.httpMethod = "GET";
        _this.httpBody = null;
        _this.headers = [];
        _this.binary = false;
        _this.download = false;
        return _this;
    }
    URLRequest.requestWithURL = function (url) {
        var request = new URLRequest();
        request.initWithURL(url);
        return request;
    };
    URLRequest.prototype.initWithURL = function (url) {
        this.url = url;
    };
    URLRequest.prototype.setHeaderField = function (field, value) {
        this.headers.push({ "Field": field, "Value": value });
    };
    return URLRequest;
}(_NSObject__WEBPACK_IMPORTED_MODULE_0__.NSObject));



/***/ }),

/***/ "./sources/UUID.ts":
/*!*************************!*\
  !*** ./sources/UUID.ts ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UUID: () => (/* binding */ UUID)
/* harmony export */ });
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/**
 * Created by godshadow on 15/3/16.
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UUID = /** @class */ (function (_super) {
    __extends(UUID, _super);
    function UUID() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Deprecated
    UUID.UUID = function () {
        var uuid = new UUID();
        uuid.init();
        return uuid;
    };
    UUID.prototype.init = function () {
        this._uuid = (0,mio_core__WEBPACK_IMPORTED_MODULE_0__.MIOCoreUUIDcreate)();
    };
    Object.defineProperty(UUID.prototype, "UUIDString", {
        get: function () {
            return this._uuid;
        },
        enumerable: false,
        configurable: true
    });
    return UUID;
}(_NSObject__WEBPACK_IMPORTED_MODULE_1__.NSObject));



/***/ }),

/***/ "./sources/UserDefaults.ts":
/*!*********************************!*\
  !*** ./sources/UserDefaults.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserDefaults: () => (/* binding */ UserDefaults)
/* harmony export */ });
/**
 * Created by godshadow on 29/09/2016.
 */
var UserDefaults = /** @class */ (function () {
    function UserDefaults() {
        if (UserDefaults._sharedInstance) {
            throw new Error("Error: Instantiation failed: Use standardUserDefaults() instead of new.");
        }
        UserDefaults._sharedInstance = this;
    }
    UserDefaults.standardUserDefaults = function () {
        return UserDefaults._sharedInstance;
    };
    UserDefaults.prototype.setBooleanForKey = function (key, value) {
        var v = value ? "1" : "0";
        this.setValueForKey(key, v);
    };
    UserDefaults.prototype.booleanForKey = function (key) {
        var v = this.valueForKey(key);
        return v == "1" ? true : false;
    };
    UserDefaults.prototype.setValueForKey = function (key, value) {
        localStorage.setItem(key, value);
    };
    UserDefaults.prototype.valueForKey = function (key) {
        return localStorage.getItem(key);
    };
    UserDefaults.prototype.removeValueForKey = function (key) {
        localStorage.removeItem(key);
    };
    UserDefaults._sharedInstance = new UserDefaults();
    return UserDefaults;
}());



/***/ }),

/***/ "./sources/XMLParser.ts":
/*!******************************!*\
  !*** ./sources/XMLParser.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   XMLParser: () => (/* binding */ XMLParser),
/* harmony export */   XMLTokenType: () => (/* binding */ XMLTokenType)
/* harmony export */ });
/* harmony import */ var _NSLog__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NSLog */ "./sources/NSLog.ts");
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var XMLTokenType;
(function (XMLTokenType) {
    XMLTokenType[XMLTokenType["Identifier"] = 0] = "Identifier";
    XMLTokenType[XMLTokenType["QuestionMark"] = 1] = "QuestionMark";
    XMLTokenType[XMLTokenType["ExclamationMark"] = 2] = "ExclamationMark";
    XMLTokenType[XMLTokenType["OpenTag"] = 3] = "OpenTag";
    XMLTokenType[XMLTokenType["CloseTag"] = 4] = "CloseTag";
    XMLTokenType[XMLTokenType["Slash"] = 5] = "Slash";
    XMLTokenType[XMLTokenType["Quote"] = 6] = "Quote";
    XMLTokenType[XMLTokenType["WhiteSpace"] = 7] = "WhiteSpace";
    XMLTokenType[XMLTokenType["End"] = 8] = "End";
})(XMLTokenType || (XMLTokenType = {}));
var XMLParser = /** @class */ (function (_super) {
    __extends(XMLParser, _super);
    function XMLParser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.delegate = null;
        _this.strIndex = 0;
        _this.elements = [];
        _this.attributes = null;
        _this.currentElement = null;
        _this.currentTokenValue = null;
        _this.lastTokenValue = null;
        _this.ignoreWhiteSpace = false;
        return _this;
    }
    XMLParser.prototype.initWithString = function (str, delegate) {
        this.str = str;
        this.delegate = delegate;
    };
    // LEXER / TOKENIZER
    XMLParser.prototype.nextChar = function () {
        if (this.strIndex >= this.str.length)
            return null;
        var ch = this.str.charAt(this.strIndex);
        this.strIndex++;
        return ch;
    };
    XMLParser.prototype.prevChar = function () {
        this.strIndex--;
        return this.str.charAt(this.strIndex);
    };
    XMLParser.prototype.readToken = function () {
        var exit = false;
        var value = "";
        while (exit == false) {
            var ch = this.nextChar();
            if (ch == null)
                return null;
            if (ch == "<" || ch == ">" || ch == "/" || ch == "?" || ch == "!") {
                if (value.length > 0)
                    this.prevChar();
                else
                    value = ch;
                exit = true;
            }
            else if (ch == "\"" || ch == "'") {
                value += ch;
                var ch2 = this.nextChar();
                while (ch2 != ch && ch2 != "<") {
                    value += ch2;
                    ch2 = this.nextChar();
                }
                if (ch2 != "<")
                    value += ch2;
                else
                    this.prevChar();
            }
            else if (ch == " ") {
                if (this.ignoreWhiteSpace == false) {
                    if (value != "")
                        this.prevChar();
                    else
                        value = " ";
                }
                exit = true;
            }
            else
                value += ch;
        }
        return value;
    };
    XMLParser.prototype.nextToken = function () {
        this.lastTokenValue = this.currentTokenValue;
        var exit = false;
        var token = XMLTokenType.Identifier;
        var value = this.readToken();
        if (value == null)
            return [XMLTokenType.End, null];
        switch (value) {
            case "<":
                token = XMLTokenType.OpenTag;
                break;
            case ">":
                token = XMLTokenType.CloseTag;
                break;
            case "/":
                token = XMLTokenType.Slash;
                break;
            case "?":
                token = XMLTokenType.QuestionMark;
                break;
            case "!":
                token = XMLTokenType.ExclamationMark;
                break;
            case " ":
                token = XMLTokenType.WhiteSpace;
                break;
            default:
                break;
        }
        this.currentTokenValue = token;
        return [token, value];
    };
    XMLParser.prototype.prevToken = function () {
        return this.lastTokenValue;
    };
    //
    // Parser
    //
    XMLParser.prototype.parse = function () {
        //console.log("**** Start parser")
        var _a, _b;
        var _c, _d;
        if (typeof ((_c = this.delegate) === null || _c === void 0 ? void 0 : _c.parserDidStartDocument) === "function")
            this.delegate.parserDidStartDocument(this);
        var token, value;
        _a = this.nextToken(), token = _a[0], value = _a[1];
        while (token != XMLTokenType.End) {
            switch (token) {
                case XMLTokenType.OpenTag:
                    this.ignoreWhiteSpace = true;
                    this.openTag();
                    this.ignoreWhiteSpace = false;
                    break;
                case XMLTokenType.Identifier:
                case XMLTokenType.Slash:
                case XMLTokenType.WhiteSpace:
                    this.text(value);
                    break;
                default:
                    break;
            }
            _b = this.nextToken(), token = _b[0], value = _b[1];
        }
        //console.log("**** End parser")
        if (typeof ((_d = this.delegate) === null || _d === void 0 ? void 0 : _d.parserDidEndDocument) === "function")
            this.delegate.parserDidEndDocument(this);
    };
    XMLParser.prototype.openTag = function () {
        //console.log("Open Tag");
        var _a;
        this.attributes = {};
        var token, value;
        _a = this.nextToken(), token = _a[0], value = _a[1];
        switch (token) {
            case XMLTokenType.Identifier:
                this.beginElement(value);
                break;
            case XMLTokenType.QuestionMark:
                this.questionMark();
                break;
            case XMLTokenType.ExclamationMark:
                this.exclamationMark();
                break;
            case XMLTokenType.Slash:
                this.slash();
                break;
            default:
                this.error("Expected: element");
                break;
        }
    };
    XMLParser.prototype.questionMark = function () {
        var _a;
        //console.log("Question mark");
        var token, val;
        _a = this.nextToken(), token = _a[0], val = _a[1];
        switch (token) {
            case XMLTokenType.Identifier:
                this.xmlOpenTag(val);
                break;
            case XMLTokenType.CloseTag:
                this.xmlCloseTag();
                break;
            default:
                break;
        }
    };
    XMLParser.prototype.exclamationMark = function () {
        var ch = this.nextChar();
        var foundMark = 0;
        if (ch == "-") {
            foundMark++;
            ch = this.nextChar();
            if (ch == "-") {
                foundMark++;
            }
        }
        if (foundMark < 2) {
            for (var i = 0; i < foundMark; i++) {
                this.prevChar();
            }
        }
        else {
            var comments = "";
            var exit = false;
            while (exit == false) {
                var ch2 = this.nextChar();
                if (ch2 == null)
                    throw new Error("NSXMLParser: Unexpected end of file!");
                comments += ch2;
                if (comments.length >= 3 && comments.substr(-3) == "-->")
                    exit = true;
            }
            this.comments(comments.substr(0, comments.length - 3));
        }
    };
    XMLParser.prototype.xmlOpenTag = function (value) {
        //console.log("XML open tag");
        var _a;
        var token, val;
        _a = this.nextToken(), token = _a[0], val = _a[1];
        switch (token) {
            case XMLTokenType.Identifier:
                this.attribute(val);
                break;
            case XMLTokenType.QuestionMark:
                this.questionMark();
                break;
            default:
                break;
        }
    };
    XMLParser.prototype.xmlCloseTag = function () {
        //console.log("XML close tag");
    };
    XMLParser.prototype.beginElement = function (value) {
        //console.log("Begin Element: " + value);
        var _a;
        this.elements.push(value);
        this.currentElement = value;
        this.attributes = {};
        var token, val;
        _a = this.nextToken(), token = _a[0], val = _a[1];
        switch (token) {
            case XMLTokenType.Identifier:
                this.attribute(val);
                break;
            case XMLTokenType.Slash:
                this.slash();
                break;
            case XMLTokenType.CloseTag:
                this.closeTag();
                this.didStartElement();
                break;
            default:
                break;
        }
    };
    XMLParser.prototype.endElement = function (value) {
        //console.log("End Element: " + value);
        var _a;
        //this.elements.push(value);
        this.attributes = {};
        this.currentElement = null;
        var token, val;
        _a = this.nextToken(), token = _a[0], val = _a[1];
        switch (token) {
            case XMLTokenType.CloseTag:
                this.closeTag();
                this.didEndElement();
                break;
            default:
                this.error("Expected: close token");
                break;
        }
    };
    XMLParser.prototype.attribute = function (attr) {
        //console.log("Attribute: " + attr);
        var _a;
        this.decodeAttribute(attr);
        var token, value;
        _a = this.nextToken(), token = _a[0], value = _a[1];
        switch (token) {
            case XMLTokenType.Identifier:
                this.attribute(value);
                break;
            case XMLTokenType.Slash:
                this.slash();
                break;
            case XMLTokenType.QuestionMark:
                this.questionMark();
                break;
            case XMLTokenType.CloseTag:
                this.closeTag();
                this.didStartElement();
                break;
            default:
                break;
        }
    };
    XMLParser.prototype.decodeAttribute = function (attr) {
        var key = null;
        var value = null;
        var token = "";
        for (var index = 0; index < attr.length; index++) {
            var ch = attr[index];
            if (ch == "=") {
                key = token;
                token = "";
            }
            else if (ch == "\"" || ch == "'") {
                index++;
                var ch2 = attr[index];
                while (ch2 != ch) {
                    token += ch2;
                    index++;
                    ch2 = attr[index];
                }
            }
            else {
                token += ch;
            }
        }
        if (key != null && token.length > 0)
            value = token;
        else if (key == null && token.length > 0)
            key = token;
        this.attributes[key] = value;
    };
    XMLParser.prototype.slash = function () {
        var _a;
        var token, value;
        _a = this.nextToken(), token = _a[0], value = _a[1];
        switch (token) {
            case XMLTokenType.CloseTag:
                this.closeTag();
                this.didStartElement();
                this.didEndElement();
                break;
            case XMLTokenType.Identifier:
                this.endElement(value);
                break;
            default:
                break;
        }
    };
    XMLParser.prototype.closeTag = function () {
        //console.log("Close Tag");
    };
    XMLParser.prototype.didStartElement = function () {
        var _a;
        var element = this.currentElement;
        //console.log("Start Element: " + element);
        if (typeof ((_a = this.delegate) === null || _a === void 0 ? void 0 : _a.parserDidStartElement) === "function")
            this.delegate.parserDidStartElement(this, element, this.attributes);
        this.currentElement = null;
        this.attributes = {};
    };
    XMLParser.prototype.didEndElement = function () {
        var _a;
        var element = this.elements.pop();
        //console.log("End Element " + element);        
        if (typeof ((_a = this.delegate) === null || _a === void 0 ? void 0 : _a.parserDidEndElement) === "function")
            this.delegate.parserDidEndElement(this, element);
    };
    XMLParser.prototype.text = function (value) {
        var _a;
        //console.log("Text: " + value);
        if (typeof ((_a = this.delegate) === null || _a === void 0 ? void 0 : _a.parserFoundCharacters) === "function")
            this.delegate.parserFoundCharacters(this, value);
    };
    XMLParser.prototype.comments = function (comment) {
        var _a;
        if (typeof ((_a = this.delegate) === null || _a === void 0 ? void 0 : _a.parserFoundComment) === "function")
            this.delegate.parserFoundComment(this, comment);
    };
    XMLParser.prototype.error = function (expected) {
        (0,_NSLog__WEBPACK_IMPORTED_MODULE_0__.NSLog)("Error: Unexpected token. " + expected);
    };
    return XMLParser;
}(_NSObject__WEBPACK_IMPORTED_MODULE_1__.NSObject));



/***/ }),

/***/ "mio-core":
/*!***************************!*\
  !*** external "mio-core" ***!
  \***************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_mio_core__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./sources/_index.ts ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bundle: () => (/* reexport safe */ _Bundle__WEBPACK_IMPORTED_MODULE_1__.Bundle),
/* harmony export */   Calendar: () => (/* reexport safe */ _Calendar__WEBPACK_IMPORTED_MODULE_12__.Calendar),
/* harmony export */   CalendarUnit: () => (/* reexport safe */ _Calendar__WEBPACK_IMPORTED_MODULE_12__.CalendarUnit),
/* harmony export */   DateFormatter: () => (/* reexport safe */ _DateFormatter__WEBPACK_IMPORTED_MODULE_4__.DateFormatter),
/* harmony export */   DateFormatterStyle: () => (/* reexport safe */ _DateFormatter__WEBPACK_IMPORTED_MODULE_4__.DateFormatterStyle),
/* harmony export */   Error: () => (/* reexport safe */ _Error__WEBPACK_IMPORTED_MODULE_6__.Error),
/* harmony export */   Formatter: () => (/* reexport safe */ _Formatter__WEBPACK_IMPORTED_MODULE_7__.Formatter),
/* harmony export */   ISO8601DateFormatter: () => (/* reexport safe */ _ISO8601DateFormatter__WEBPACK_IMPORTED_MODULE_9__.ISO8601DateFormatter),
/* harmony export */   IndexPath: () => (/* reexport safe */ _IndexPath__WEBPACK_IMPORTED_MODULE_8__.IndexPath),
/* harmony export */   Locale: () => (/* reexport safe */ _Locale__WEBPACK_IMPORTED_MODULE_11__.Locale),
/* harmony export */   NSClassFromString: () => (/* reexport safe */ _NSClassFromString__WEBPACK_IMPORTED_MODULE_3__.NSClassFromString),
/* harmony export */   NSCoder: () => (/* reexport safe */ _NSCoder__WEBPACK_IMPORTED_MODULE_2__.NSCoder),
/* harmony export */   NSDecimalNumber: () => (/* reexport safe */ _DecimalNumber__WEBPACK_IMPORTED_MODULE_5__.NSDecimalNumber),
/* harmony export */   NSEqualRanges: () => (/* reexport safe */ _NSRange__WEBPACK_IMPORTED_MODULE_19__.NSEqualRanges),
/* harmony export */   NSIntersectionRange: () => (/* reexport safe */ _NSRange__WEBPACK_IMPORTED_MODULE_19__.NSIntersectionRange),
/* harmony export */   NSKeyedUnarchiver: () => (/* reexport safe */ _KeyedUnarchiver__WEBPACK_IMPORTED_MODULE_10__.NSKeyedUnarchiver),
/* harmony export */   NSLocalizeString: () => (/* reexport safe */ _NSString__WEBPACK_IMPORTED_MODULE_22__.NSLocalizeString),
/* harmony export */   NSLocationInRange: () => (/* reexport safe */ _NSRange__WEBPACK_IMPORTED_MODULE_19__.NSLocationInRange),
/* harmony export */   NSLog: () => (/* reexport safe */ _NSLog__WEBPACK_IMPORTED_MODULE_14__.NSLog),
/* harmony export */   NSMaxRange: () => (/* reexport safe */ _NSRange__WEBPACK_IMPORTED_MODULE_19__.NSMaxRange),
/* harmony export */   NSNull: () => (/* reexport safe */ _NSNull__WEBPACK_IMPORTED_MODULE_15__.NSNull),
/* harmony export */   NSNumber: () => (/* reexport safe */ _NSNumber__WEBPACK_IMPORTED_MODULE_16__.NSNumber),
/* harmony export */   NSObject: () => (/* reexport safe */ _NSObject__WEBPACK_IMPORTED_MODULE_17__.NSObject),
/* harmony export */   NSPredicate: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicate),
/* harmony export */   NSPredicateBitwiseOperatorType: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateBitwiseOperatorType),
/* harmony export */   NSPredicateComparatorType: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateComparatorType),
/* harmony export */   NSPredicateGroup: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateGroup),
/* harmony export */   NSPredicateItem: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateItem),
/* harmony export */   NSPredicateItemValueType: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateItemValueType),
/* harmony export */   NSPredicateOperator: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateOperator),
/* harmony export */   NSPredicateOperatorType: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateOperatorType),
/* harmony export */   NSPredicateRelationshipOperatorType: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateRelationshipOperatorType),
/* harmony export */   NSPredicateType: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__.NSPredicateType),
/* harmony export */   NSRange: () => (/* reexport safe */ _NSRange__WEBPACK_IMPORTED_MODULE_19__.NSRange),
/* harmony export */   NSSet: () => (/* reexport safe */ _NSSet__WEBPACK_IMPORTED_MODULE_20__.NSSet),
/* harmony export */   NSSortDescriptor: () => (/* reexport safe */ _NSSortDescriptor__WEBPACK_IMPORTED_MODULE_21__.NSSortDescriptor),
/* harmony export */   NSUnionRange: () => (/* reexport safe */ _NSRange__WEBPACK_IMPORTED_MODULE_19__.NSUnionRange),
/* harmony export */   Notification: () => (/* reexport safe */ _NotificationCenter__WEBPACK_IMPORTED_MODULE_13__.Notification),
/* harmony export */   NotificationCenter: () => (/* reexport safe */ _NotificationCenter__WEBPACK_IMPORTED_MODULE_13__.NotificationCenter),
/* harmony export */   NumberFormatter: () => (/* reexport safe */ _NumberFormatter__WEBPACK_IMPORTED_MODULE_23__.NumberFormatter),
/* harmony export */   Operation: () => (/* reexport safe */ _Operation__WEBPACK_IMPORTED_MODULE_24__.Operation),
/* harmony export */   OperationQueue: () => (/* reexport safe */ _OperationQueue__WEBPACK_IMPORTED_MODULE_25__.OperationQueue),
/* harmony export */   PropertyListFormat: () => (/* reexport safe */ _PropertyListSerialization__WEBPACK_IMPORTED_MODULE_26__.PropertyListFormat),
/* harmony export */   PropertyListReadOptions: () => (/* reexport safe */ _PropertyListSerialization__WEBPACK_IMPORTED_MODULE_26__.PropertyListReadOptions),
/* harmony export */   PropertyListSerialization: () => (/* reexport safe */ _PropertyListSerialization__WEBPACK_IMPORTED_MODULE_26__.PropertyListSerialization),
/* harmony export */   PropertyListWriteOptions: () => (/* reexport safe */ _PropertyListSerialization__WEBPACK_IMPORTED_MODULE_26__.PropertyListWriteOptions),
/* harmony export */   Timer: () => (/* reexport safe */ _Timer__WEBPACK_IMPORTED_MODULE_27__.Timer),
/* harmony export */   URLConnection: () => (/* reexport safe */ _URLConnection__WEBPACK_IMPORTED_MODULE_29__.URLConnection),
/* harmony export */   URLRequest: () => (/* reexport safe */ _URLRequest__WEBPACK_IMPORTED_MODULE_30__.URLRequest),
/* harmony export */   UUID: () => (/* reexport safe */ _UUID__WEBPACK_IMPORTED_MODULE_32__.UUID),
/* harmony export */   UserDefaults: () => (/* reexport safe */ _UserDefaults__WEBPACK_IMPORTED_MODULE_31__.UserDefaults),
/* harmony export */   XMLParser: () => (/* reexport safe */ _XMLParser__WEBPACK_IMPORTED_MODULE_33__.XMLParser),
/* harmony export */   XMLTokenType: () => (/* reexport safe */ _XMLParser__WEBPACK_IMPORTED_MODULE_33__.XMLTokenType),
/* harmony export */   _MIOBundleAppGetResource: () => (/* reexport safe */ _Bundle__WEBPACK_IMPORTED_MODULE_1__._MIOBundleAppGetResource),
/* harmony export */   _MIOBundleCreateBundle: () => (/* reexport safe */ _Bundle__WEBPACK_IMPORTED_MODULE_1__._MIOBundleCreateBundle),
/* harmony export */   _MIOBundleLoadBundles: () => (/* reexport safe */ _Bundle__WEBPACK_IMPORTED_MODULE_1__._MIOBundleLoadBundles),
/* harmony export */   _MIOBundleResourceDownloadCheck: () => (/* reexport safe */ _Bundle__WEBPACK_IMPORTED_MODULE_1__._MIOBundleResourceDownloadCheck),
/* harmony export */   _MIOBundleSetResource: () => (/* reexport safe */ _Bundle__WEBPACK_IMPORTED_MODULE_1__._MIOBundleSetResource),
/* harmony export */   _NSPredicateFilterObjects: () => (/* reexport safe */ _NSPredicate__WEBPACK_IMPORTED_MODULE_18__._NSPredicateFilterObjects),
/* harmony export */   _NSSortDescriptorSortObjects: () => (/* reexport safe */ _NSSortDescriptor__WEBPACK_IMPORTED_MODULE_21__._NSSortDescriptorSortObjects)
/* harmony export */ });
/* harmony import */ var _Array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Array */ "./sources/Array.ts");
/* harmony import */ var _Bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Bundle */ "./sources/Bundle.ts");
/* harmony import */ var _NSCoder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./NSCoder */ "./sources/NSCoder.ts");
/* harmony import */ var _NSClassFromString__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./NSClassFromString */ "./sources/NSClassFromString.ts");
/* harmony import */ var _DateFormatter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./DateFormatter */ "./sources/DateFormatter.ts");
/* harmony import */ var _DecimalNumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./DecimalNumber */ "./sources/DecimalNumber.ts");
/* harmony import */ var _Error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Error */ "./sources/Error.ts");
/* harmony import */ var _Formatter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Formatter */ "./sources/Formatter.ts");
/* harmony import */ var _IndexPath__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./IndexPath */ "./sources/IndexPath.ts");
/* harmony import */ var _ISO8601DateFormatter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ISO8601DateFormatter */ "./sources/ISO8601DateFormatter.ts");
/* harmony import */ var _KeyedUnarchiver__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./KeyedUnarchiver */ "./sources/KeyedUnarchiver.ts");
/* harmony import */ var _Locale__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Locale */ "./sources/Locale.ts");
/* harmony import */ var _Calendar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Calendar */ "./sources/Calendar.ts");
/* harmony import */ var _NotificationCenter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./NotificationCenter */ "./sources/NotificationCenter.ts");
/* harmony import */ var _NSLog__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./NSLog */ "./sources/NSLog.ts");
/* harmony import */ var _NSNull__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./NSNull */ "./sources/NSNull.ts");
/* harmony import */ var _NSNumber__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./NSNumber */ "./sources/NSNumber.ts");
/* harmony import */ var _NSObject__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./NSObject */ "./sources/NSObject.ts");
/* harmony import */ var _NSPredicate__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./NSPredicate */ "./sources/NSPredicate.ts");
/* harmony import */ var _NSRange__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./NSRange */ "./sources/NSRange.ts");
/* harmony import */ var _NSSet__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./NSSet */ "./sources/NSSet.ts");
/* harmony import */ var _NSSortDescriptor__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./NSSortDescriptor */ "./sources/NSSortDescriptor.ts");
/* harmony import */ var _NSString__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./NSString */ "./sources/NSString.ts");
/* harmony import */ var _NumberFormatter__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./NumberFormatter */ "./sources/NumberFormatter.ts");
/* harmony import */ var _Operation__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./Operation */ "./sources/Operation.ts");
/* harmony import */ var _OperationQueue__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./OperationQueue */ "./sources/OperationQueue.ts");
/* harmony import */ var _PropertyListSerialization__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./PropertyListSerialization */ "./sources/PropertyListSerialization.ts");
/* harmony import */ var _Timer__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./Timer */ "./sources/Timer.ts");
/* harmony import */ var _URL__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./URL */ "./sources/URL.ts");
/* harmony import */ var _URLConnection__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./URLConnection */ "./sources/URLConnection.ts");
/* harmony import */ var _URLRequest__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./URLRequest */ "./sources/URLRequest.ts");
/* harmony import */ var _UserDefaults__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./UserDefaults */ "./sources/UserDefaults.ts");
/* harmony import */ var _UUID__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./UUID */ "./sources/UUID.ts");
/* harmony import */ var _XMLParser__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./XMLParser */ "./sources/XMLParser.ts");



































})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=foundation.js.map